/* eslint-disable */
import  { useState, useReducer, useEffect, useRef } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import * as createActions from "../../actions/createTrial.js";
import { Collapse, Modal, Row, Col, InputNumber, Tooltip, Button, message, Badge, Table, Select, Input, Radio,} from "antd";
import { MinusOutlined, PlusOutlined, CarryOutFilled, DeleteOutlined, CheckCircleFilled, InfoCircleOutlined, SearchOutlined} from "@ant-design/icons";
import ReactECharts from 'echarts-for-react';
import {getStandardEvents, update_patient_burden, getChartsData, getTrialSoaInsights, getTrialSoa, getTrialSBInsights} from "../../utils/ajax-proxy"; 
import { toSentenceCase, formatWithCommas, convertToHours, displayTimeInHoursOrMins } from '../../utils/utils';
import "./index.scss";
import NewEventList from '../NewEventList';
import SOAConfigure from '../SOAConfigure';
import ActivitiesByModality from '../ActivitiesByModality'
import { getEmail } from "../../utils/auth";
import { SortOrder } from 'antd/lib/table/interface';
import SoaAtGlance from '../../components/SoaAtGlance';
import telehealth_icon from '../../assets/telemedicine.png';
import patient_at_home_icon from '../../assets/home-health.png';
import hospital_icon from '../../assets/traditionalSite.png';
import mobile_health_icon from '../../assets/esource.png';
import pharmacy_icon from '../../assets/local-clinic.png';
import local_lab_icon from '../../assets/local-Lab.png';
import ip_direct_icon from '../../assets/ipDirectShipment.png'
import e_consent_icon from '../../assets/econsent.png';

import { defaultChartData } from '../../pages/ChartSummary';
import {  getChartOptions } from '../../utils/common-function';
import { useChartTooltip } from "src/Hooks/useChartTooltip";
import VisitLevelAnalysis from '../../components/VisitLevelAnalysis';
import { VisitLevelAnalysisDataType } from "src/pages/ChartSummary/types.js";

const { Panel } = Collapse;
const { Option } = Select;

const iChartColors = ['#DADADA', '#DADADA', '#DADADA', '#DADADA', '#DADADA']
const aChartColors = ['#d04a02', '#ed7738', '#ed9d72', '#f5b795', '#f5ddcf']
const burdenColors = {active: '#E53500', inactive: '#DADADA'}
const aLabelColors = {GOOD: '#00A947', FAIR: '#0084A9', POOR: '#c33232'}
const iLabelColors = {GOOD: burdenColors.inactive, FAIR: burdenColors.inactive, POOR: burdenColors.inactive}

const CATEGORY_LABS = 'Labs';
const CATEGORY_PHYSICAL_EXAMINATION = 'Physical Examination';
const CATEGORY_PROCEDURES = 'Procedures';
const CATEGORY_QUESTIONNAIRES = 'Questionnaires';
const CATEGORY_STUDY_PROCEDURES = 'Study Procedures';

// Sets min and max ranges for Criteria Frequency slider
const FREQUENCY_RANGE_MIN = 0
const FREQUENCY_RANGE_MAX = 100

const defaultCostValue = [
  {value: 0, name: CATEGORY_LABS},
  {value: 0, name: CATEGORY_PHYSICAL_EXAMINATION},
  {value: 0, name: CATEGORY_PROCEDURES},
  {value: 0, name: CATEGORY_QUESTIONNAIRES},
  {value: 0, name: CATEGORY_STUDY_PROCEDURES}
]

const defaultBurdenValue = [0, 0, 0, 0, 0, 0, 0, 0, 0]

const initEventCriteria = {
  'TotalCost': '0',
  'CostRate': '',
  'CostData': [],
  // 'BurdenData': [],
  // 'BurdenXAxis': [],
  'Finished': false
}

const initialSoa = { 
  soaAddedLabs: [],
  soaAddedExamination: [],
  soaAddedProcedures: [],
  soaAddedQuestionnaires: [],
  soaAddedStudyProcedures: [],
  soaOrgLabs: [],
  soaOrgExamination: [],
  soaOrgProcedures: [],
  soaOrgQuestionnaires: [],
  soaOrgStudyProcedures: [],
  soaFilteredLabs: [],
  soaFilteredExamination: [],
  soaFilteredQuestionnaires: [],
  soaFilteredProcedures: [],
  soaFilteredStudyProcedures: [],
  soaEndpoints : [],
  soaVisits: [],
  soaWeeks: [],
  isLoaded: false,
  event_numbers: {},
  soaDismissEvent: [],
  soaInsightEvent: null,
  soaPeriod_data: [],
  totalTrialDismissedActivity: []
  // soaOncologyFlag: false,
  // currentVisitTypes: 'total_trial',
}

const initialEndpoint = {   
  endpointOrg: [], 
  endpointAdded: [], 
  endpointDismissEvent: [],
  endpointInsightEvent: null,
  trialEndpointData: null,
}

const ScheduleActivities = (props) => { 
  const { trialUserRole, trialUUID, pageLoading,scenarioId, scenarioType } = props; 
  
    const endpoints = {
        "Primary Endpoints": props.newSoa.primary_endpoints,
        "Secondary Endpoints": props.newSoa.secondary_endpoints,
        "Tertiary Endpoints": props.newSoa.exploratory_endpoints,
      };
      const scenario = props.newSoa.scenarios && props.newSoa.scenarios.find(s=> s['ts_id'] == localStorage.getItem('ts_id'));  
      const eventsConfigure = scenario&&scenario['Schedule of Activities'];
      const [hiddeTags, setHiddeTags] = useState(true)
      const [showConfigure, setShowConfigure] = useState(false)
      const [eventLib, setEventLib] = useState(6)
      const [eventPanel, setEventPanel] = useState("1")
      const [dismissEvent, setDismissEvent] = useState([])
      // const [insightEvent, setInsightEvent] = useState(scenario&&scenario['soa_insights']? scenario['soa_insights']:[])
      // scenario&&scenario['soa_insights']? scenario['soa_insights']:[]
      const [insightEvent, setInsightEvent] = useState([]) 
      const [isSave,setIsSave] = useState(false)
      const [numbers, setNumbers] = useReducer(
        (state, newState) => ({ ...state, ...newState }),
        { 
          // visitNumber: eventsConfigure?.visits.length || 0,
          // ScreeningVisits: eventsConfigure?.ScreeningVisits || 0,
          // TreatmentVisits: eventsConfigure?.TreatmentVisits || 0,
          // FollowupVisits: eventsConfigure?.FollowupVisits || 0,
          weekNumber: eventsConfigure?.Weeks? eventsConfigure.Weeks[eventsConfigure.Weeks?.length-1]: 0
         }
      );

      const [visitNoteList, setVisitNoteList] = useState(eventsConfigure?.visitNoteList || []);
    
      const [editNumbers, setEditNumbers] = useState({
        // screeningVisitsNumber: eventsConfigure?.ScreeningVisits || 0,
        // treatmentVisitsNumber:  eventsConfigure?.TreatmentVisits || 0,
        // followupVisitsNumber: eventsConfigure?.FollowupVisits || 0,
        weekNumber: eventsConfigure?.Weeks? eventsConfigure.Weeks[eventsConfigure.Weeks?.length-1]: 0
      });

      // use this one to replace screeningVisitsNumber treatmentVisitsNumber and followupVisitsNumber
      // const [periodType, setPeriodType] = useState(eventsConfigure?.period_data?.map((item,index)=>{
      //   item.period_id =  item.period_id === null?item.visit_type_id : index+1
      //   item.period_name = item.period_name === null?item.visit_type : item.period_name    
      //   return {
      //     ...item
      //   }
      // }) || []);

      const [weeks, setWeeks] = useState([])
      const [visits, setVisits] = useState([])
      const [eventCriteria, setEventCriteria] = useReducer(
        (state, newState) => ({ ...state, ...newState }),
        { ...initEventCriteria }
      );
    
      const [prevCategoryVisists, setPreviousCategoryVisits] = useState({});
      const [soaOncologyFlag , setSoaOncologyFlag ] = useState(false);

      const [periodDataDetails, setPeriodDataDetails] = useState([]);
      const [patientBurdenTooltipVisible, setPatientBurdenTooltipVisible] = useState(null);
      const [siteBurdenTooltipVisible, setSiteBurdenTooltipVisible] = useState(null);

      useEffect(() => {
        if(!eventsConfigure?.VisitTypes) return;
       
          setPreviousCategoryVisits({
            ScreeningVisits: eventsConfigure?.VisitTypes?.ScreeningVisits || 0,
            TreatmentVisits:  eventsConfigure?.VisitTypes?.TreatmentVisits || 0,
            FollowupVisits: eventsConfigure?.VisitTypes?.FollowupVisits || 0,
            weekNumber:eventsConfigure.Weeks?eventsConfigure.Weeks[eventsConfigure.Weeks?.length-1]: 0
          })
      }, [eventsConfigure?.VisitTypes])
      
      //Cost Per Patient Chart
      const [costData, setCostData] = useState(defaultCostValue)
    
      //Patient Burden Chart
      const [burdenData, setBurdenData] = useState(defaultBurdenValue) 
      const [burdenXAxis, setBurdenXAxis] = useState(['1', '2', '3', '4', '5', '6', '7', '8', '9']) 
      const [submitType, setSubmitType] = useState(0)
      const [numberOfScreeningVisitsError, setNumberOfScreeningVisitsError] = useState("")
      const [numberOfTreatmentVisitsError, setNumberOfTreatmentVisitsError] = useState("")
      const [numberOfFollowupVisitsError, setNumberOfFollowupVisitsError] = useState("")
      const [numberOfWeeksError, setNumberOfWeeksError] = useState("")
    
      const [modalityOptions, setModalityOptions] = useState([])
      const [soeLibrarayPanelStatus, setSOELibraryPanelStatus] = useState(false)
      const soeInsightsToggleHandler = (status) => {
        setSOELibraryPanelStatus(status);
        setEventLib(!status ? 0 : 6)
      } 
 

       useEffect(()=> {
        // If no data loaded, don't show configure pop up to avoid other errors
        if(!props.newSoa?.scenarios|| !(props?.newSoa?.soaFilteredLabs?.length > 0 ||    
          props?.newSoa?.soaFilteredExamination.length > 0 ||
          props?.newSoa?.soaFilteredQuestionnaires?.length > 0 ||
          props?.newSoa?.soaFilteredProcedures?.length > 0 ||
          props?.newSoa?.soaFilteredStudyProcedures?.length > 0 )){
          return;
        } 
        
      }, [props.newSoa])  

       useEffect(() => {
        const handleScroll = () => {
          setPatientBurdenTooltipVisible(null);
          setSiteBurdenTooltipVisible(null);
        };
    
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
      }, []);

     
      //Activities by Modality chart
      const[modalityChartOrgData,setModalityChartOrgData] = useState([])
      const[modalityChartData,setModalityChartData] = useState([])
    
      const modality_options_dict ={
          "eSource & Wearables": {
            "icon": mobile_health_icon,
            "color": '#FFB600'
          },
          "Telemedicine": {
            "icon": telehealth_icon,
            "color": '#3DD5B0'
          },
          "Home Health": {
            "icon": patient_at_home_icon,
            "color": '#295477'
          },
          "Local Lab & Sample Collection": {
            "icon": local_lab_icon,
            "color": '#657DFF'
          },
          "Local Clinic": {
            "icon": pharmacy_icon,
            "color": '#E72B33'
          },
          "IP Direct Shipment": {
            "icon": ip_direct_icon,
            "color": '#00C6F7'
          },
          "eConsent": {
            "icon": e_consent_icon,
            "color": '#299D8F'
          },
          "Traditional Site": {
            "icon": hospital_icon,
            "color":'#D93954'
          },
          "": {
            "icon":'',
            "color":'white'
          }
        }
    
      //Event Libs
      //Original data from backend
      const [orgLabs, setOrgLabs] = useState([])
      const [orgExamination, setOrgExamination] = useState([])
      const [orgProcedures, setOrgProcedures] = useState([])
      const [orgQuestionnaires, setOrgQuestionnaires] = useState([])
      const [orgStudyProcedures, setOrgStudyProcedures] = useState([])
    
      //Filtered data based on the frequency and original data
      let [filteredLabs, setFilteredLabs] = useState([])
      let [filteredExamination, setFilteredExamination] = useState([])
      let [filteredQuestionnaires, setFilteredQuestionnaires] = useState([])
      let [filteredProcedures, setFilteredProcedures] = useState([])
      let [filteredStudyProcedures, setFilteredStudyProcedures] = useState([])
    
      //Addedd data
      let [addedLabs, setAddedLabs] = useState([])
      let [addedExamination, setAddedExamination] = useState([])
      let [addedQuestionnaires, setAddedQuestionnaires] = useState([])
      let [addedProcedures, setAddedProcedures] = useState([])
      let [addedStudyProcedures, setAddedStudyProcedures] = useState([]) 

      // Chart loading state
      const [loadingSoaAtGlance, setLoadingSoaAtGlance] = useState(true);
      const [loadingActivityChart, setLoadingActivityChart]= useState(true)
      const [isChartLoading, setChartLoading] = useState(true);
      const [disableSave,setdisableSave]=useState(true)

      const [pbPerVisit, setpbPerVisit] = useState(false)
      const [sbPerVisit, setsbPerVisit] = useState(false)
      

      const handleSoALoading = (loading) => {
        setLoadingSoaAtGlance(loading);
      };
      const handleActivityLoading = (loading) => {
        setLoadingActivityChart(loading);
      };


      const [soaLoadedCharts, setSoaLoadedCharts] = useState([])
      const [ selectedChartID, setSelectedChartID ] = useState([]);

      function compareArrays(array1, array2) {  
        return array1.length === array2.length && array1.every((value, index) => value === array2[index]);  
      }  
      useEffect(() => { 
        // if((!(selectedChartID.includes(1)&&loadingSoaAtGlance) && !(selectedChartID.includes(2)&&loadingActivityChart))  || isUpdateMode){ 
        if(compareArrays(selectedChartID.sort(), soaLoadedCharts.sort())){ 
          props.setDisableSaveFinish(false)
          setdisableSave(false)
        }else{
          props.setDisableSaveFinish(true)
          setdisableSave(true)
        }
      })
    
      // const onStepScreeningVisit = (value: number, info: { offset: number, type: 'up' | 'down' }) => {
      //   setNumbers({
      //     ['ScreeningVisits']: value
      //   });
      // }
    
      // const onStepTreatmentVisit = (value: number, info: { offset: number, type: 'up' | 'down' }) => {
      //   setNumbers({
      //     ['TreatmentVisits']: value
      //   });
      // }
    
      // const onStepFollowUpVisit = (value: number, info: { offset: number, type: 'up' | 'down' }) => {
      //   setNumbers({
      //     ['FollowupVisits']: value
      //   });
      // }
    
      // const onStepWeek = (value: number, info: { offset: number, type: 'up' | 'down' }) => {
      //   setNumbers({
      //     ['weekNumber']: value
      //   });
      // }
    
      // const validateScreeningVisit = (rawValue) => {
      //   let value = parseInt(rawValue)
      //   let errorMsg = ""
      //   if(rawValue===null||rawValue===NaN||(!rawValue && value!=0)){errorMsg = "Number of treatment visits is required"}
      //   else if(value>100 || value<1){errorMsg = "Number of Screening visits should be between 1 to 100"}
      //   setNumberOfScreeningVisitsError(errorMsg)
      //   setNumbers({
      //     ['ScreeningVisits']: value
      //   });
      //   return errorMsg == ""
      // }
    
      // const validateTreatmentVisit = (rawValue) => {
      //   let value = parseInt(rawValue)
      //   let errorMsg = ""
      //   if(rawValue===null||rawValue===NaN||(!rawValue && value!=0)){errorMsg = "Number of screening visits is required"}
      //   else if(value>100 || value<1){errorMsg = "Number of Treatment Visits should be between 1 to 100"}
      //   setNumberOfTreatmentVisitsError(errorMsg)
      //   setNumbers({
      //     ['TreatmentVisits']: value
      //   });
      //   return errorMsg == ""
      // }
    
      // const validateFollowUpVisit = (rawValue) => {
      //   let value = parseInt(rawValue)
      //   let errorMsg = ""
      //   if(rawValue===null||rawValue===NaN||(!rawValue && value!=0)){errorMsg = "Number of follow up visits is required"}
      //   else if(value>100 || value<1){errorMsg = "Number of follow-up visits should be between 1 to 100"}
      //   setNumberOfFollowupVisitsError(errorMsg)
      //   setNumbers({
      //     ['FollowupVisits']: value
      //   });
      //   return errorMsg == ""
      // }
    
      // const validateWeek = (rawValue) => {
      //   let value = parseInt(rawValue)
      //   let errorMsg = ""
      //   if(rawValue===null||rawValue===NaN||(!rawValue && value!=0)){errorMsg = "Number of weeks is required"}
      //   else if(value>1000 || value<1){errorMsg = "Number of weeks should be between 1 to 1000"}
      //   setNumberOfWeeksError(errorMsg)
      //   setNumbers({
      //     ['weekNumber']: value
      //   });
      //   return errorMsg == ""
      // }
    
      const handleVisitNoteList = (noteValue) => {
      const notes = [...noteValue]
      const period_data = [...props.newSoa.soaPeriod_data]
      period_data.forEach((item, index) => {
        item.visit_notes = notes.splice(0, item.visit_notes.length)
        return item
      })
      props.updateSoaActivities({ 
        soaPeriod_data: period_data,
        soaVisitNotesList: period_data.map( item => item.visit_notes).flat()
      })
        // let tempVisitNoteList = visitNoteList ? visitNoteList : [];
        // let newVisitNoteList = [...tempVisitNoteList]
        // if( noteValue.trim().length == 0) {
        //   newVisitNoteList = tempVisitNoteList.filter((value, index) => noteValue.visit !== value.visit); 
        //   props.updateSoaActivities({ soaVisitNotesList: newVisitNoteList})
        //   return;
        // }
        // const index = tempVisitNoteList.findIndex((value, index) => noteValue == value);
        // if(index > -1) {
        //   newVisitNoteList.splice(index, 1, noteValue) 
        //   props.updateSoaActivities({ soaVisitNotesList: newVisitNoteList})
        // } else {
        //   newVisitNoteList.push(noteValue)
        // }
        // props.updateSoaActivities({ soaVisitNotesList: newVisitNoteList})
      }


  useEffect(() => {
    if(Object.keys(props.newSoa.event_numbers).length > 0) {
      const {
        // ScreeningVisits, 
        // TreatmentVisits, 
        // FollowupVisits, 
        weekNumber 
      } =  props.newSoa.event_numbers 
      setNumbers({
        // ScreeningVisits: ScreeningVisits,
        // TreatmentVisits: TreatmentVisits,
        // FollowupVisits: FollowupVisits,
        weekNumber: weekNumber
      })
      setEditNumbers({
        // screeningVisitsNumber: ScreeningVisits,
        // treatmentVisitsNumber: TreatmentVisits,
        // followupVisitsNumber: FollowupVisits,
        weekNumber:weekNumber
      })
    }
  }, [props.newSoa?.event_numbers])

  useEffect(() => {
    if(props.newSoa?.soaPeriod_data) { 
      setPeriodDataDetails(props.newSoa.soaPeriod_data)
    }
    
  }
  , [props.newSoa?.soaPeriod_data])

      const sumOfArr = (arr) => {
        if(Array.isArray(arr)){
           let  arrSum = 0
           arr.forEach((item,index) => {
            arrSum+=item
           })
           return arrSum
        }
    }
    
      const isEventsAdded = (events) => {
        return (
        (events[CATEGORY_LABS]!=undefined && events[CATEGORY_LABS].entities.length > 0)
        || (events[CATEGORY_PHYSICAL_EXAMINATION]!=undefined && events[CATEGORY_PHYSICAL_EXAMINATION].entities.length > 0)
        || (events[CATEGORY_PROCEDURES]!=undefined && events[CATEGORY_PROCEDURES].entities.length > 0)
        || (events[CATEGORY_QUESTIONNAIRES]!=undefined && events[CATEGORY_QUESTIONNAIRES].entities.length > 0)
        || (events[CATEGORY_STUDY_PROCEDURES]!=undefined && events[CATEGORY_STUDY_PROCEDURES].entities.length > 0)
        )
      }
    
      const getCostData = (costData) => {
        if(costData!=undefined && costData.length < 1){
            return [
                    {
                        "name": CATEGORY_STUDY_PROCEDURES,
                        "value": 0
                    },
                    {
                        "name": CATEGORY_PROCEDURES,
                        "value": 0
                    },
                    {
                        "name": CATEGORY_QUESTIONNAIRES,
                        "value": 0
                    },
                    {
                        "name": CATEGORY_PHYSICAL_EXAMINATION,
                        "value": 0
                    },
                    {
                        "name": CATEGORY_LABS,
                        "value": 0
                    }
                ]
        }else{
            return costData
        }
      }
    
        const getModalityOptions = (modalityOpts) =>{
            let finalModalityOptions = []
            if(modalityOpts != null && modalityOpts != undefined){
                modalityOpts.forEach((modality) => {
                    if(modality.name in modality_options_dict){
                        finalModalityOptions.push({
                            key: modality.key,
                            name:  modality.name,
                            icon: modality_options_dict[modality.name].icon,
                            color: modality_options_dict[modality.name].color
                      })
                    }else{
                      finalModalityOptions.push({
                            key: modality.key,
                            name:  modality.name,
                            icon: '',
                            color: 'white'
                      })
                    }
                });
                finalModalityOptions.push({
                    key:"",
                    name:  "",
                    icon:'',
                    color:'white'
                })
                return finalModalityOptions;
            }else{
                return []
            }
        }
    
      useEffect(() => {
        if(props.submitType != 0){
          setSubmitType(props.submitType)
        }
      },[props.submitType]);
    
      // useEffect(()=>{
      //   if(eventsConfigure?.ScreeningVisits && eventsConfigure?.TreatmentVisits && eventsConfigure?.FollowupVisits && eventsConfigure?.Weeks){  
      //     if(props.newSoa?.soaAddedLabs?.length > 0 || 
      //       props.newSoa?.soaAddedExamination?.length > 0 || 
      //       props.newSoa?.soaAddedProcedures?.length > 0 || 
      //       props.newSoa?.soaAddedQuestionnaires?.length > 0 || 
      //       props.newSoa?.soaAddedStudyProcedures?.length > 0) return
      //     setNumbers({
      //       // ScreeningVisits: eventsConfigure.ScreeningVisits,
      //       // TreatmentVisits: eventsConfigure.TreatmentVisits,
      //       // FollowupVisits: eventsConfigure.FollowupVisits,
      //       weekNumber:eventsConfigure.Weeks[eventsConfigure.Weeks.length-1]
      //     })
      //     setEditNumbers({
      //       // screeningVisitsNumber: eventsConfigure.ScreeningVisits,
      //       // treatmentVisitsNumber: eventsConfigure.TreatmentVisits,
      //       // followupVisitsNumber: eventsConfigure.FollowupVisits,
      //       weekNumber:eventsConfigure.Weeks[eventsConfigure.Weeks.length-1]
      //     })
      //   }
      // },[eventsConfigure?.ScreeningVisits, eventsConfigure?.TreatmentVisits, eventsConfigure?.FollowupVisits, eventsConfigure?.Weeks])
    
      // useEffect(()=>{
      //   if(eventsConfigure?.VisitTypes?.ScreeningVisits && eventsConfigure?.VisitTypes?.TreatmentVisits && eventsConfigure?.VisitTypes?.FollowupVisits && eventsConfigure.WeekNumber){
      //    if(props.newSoa?.soaAddedLabs?.length > 0 || 
      //     props.newSoa?.soaAddedExamination?.length > 0 || 
      //     props.newSoa?.soaAddedProcedures?.length > 0 || 
      //     props.newSoa?.soaAddedQuestionnaires?.length > 0 || 
      //     props.newSoa?.soaAddedStudyProcedures?.length > 0  ) return
      //     setNumbers({
      //       ScreeningVisits: eventsConfigure?.VisitTypes.ScreeningVisits,
      //       TreatmentVisits: eventsConfigure?.VisitTypes.TreatmentVisits,
      //       FollowupVisits: eventsConfigure?.VisitTypes.FollowupVisits,
      //       weekNumber:eventsConfigure?.Weeks[eventsConfigure.Weeks.length-1]
      //     })
      //     setEditNumbers({
      //       screeningVisitsNumber: eventsConfigure?.VisitTypes.ScreeningVisits,
      //       treatmentVisitsNumber: eventsConfigure?.VisitTypes.TreatmentVisits,
      //       followupVisitsNumber: eventsConfigure?.VisitTypes.FollowupVisits,
      //       weekNumber:eventsConfigure?.Weeks[eventsConfigure.Weeks.length-1]
      //     })
      //   }
      // },[eventsConfigure?.VisitTypes])

      useEffect(() => {
        setWeeks(props.newSoa?.soaWeeks)
      }, [props.newSoa?.soaWeeks]) 

      useEffect(()=>{
        setVisits(props.newSoa?.soaVisits)
      },[props.newSoa?.soaVisits])

      const [visitTypeLib, setVisitTypeLib] = useState([])

      const [currentVisitTypes, setCurrentVisitTypes] = useState("total_trial")
      const [currentVisitIndex, setCurrentVisitIndex] = useState([]);

      useEffect(()=>{
        setCurrentVisitTypes(props.newSoa?.currentVisitTypes)
      },[props.newSoa?.currentVisitTypes])

      // const filterDeletedItems = (addedItems, filteredItems) => {
      //   const items = addedItems?.filter( item => filteredItems?.some( item2 => item2['Standard Activity'] == item['Standard Activity'] && item2.deleted !== true))
      //   return items;
      // }
      const filterDeletedItems = (addedItems, filteredItems, entities) => {
        const items = addedItems?.filter(item => {
          const isDeletedInFiltered = filteredItems?.some(item2 => item2['Standard Activity'] == item['Standard Activity'] && item2.deleted === true);
          if (!entities || entities.length === 0) {
            return !isDeletedInFiltered;
          } else {
            const isInEntities = entities.some(entity => entity['Standard Activity'] === item['Standard Activity']);
            return !isDeletedInFiltered || isInEntities;
          }
        });
        return items;
      }

      useEffect(()=>{
        if(!periodDataDetails) return
        // Get the re-ordered visit array
        let newVisitArray = props.newSoa?.soaVisits&&props.newSoa?.soaVisits?.map((c,i) => c = i + 1)||[]
        // Update the visits array in each period
        let newPeriodType = JSON.parse(JSON.stringify(periodDataDetails))
        let _newVisits = JSON.parse(JSON.stringify(newVisitArray))
        newPeriodType?.forEach((period, index) => {
          const visits = _newVisits.splice(0, period.no_of_visits)
          period.visits = visits
        })  
        // Return the current visit array based on the visit type
        let visitArray = []
        if (props.newSoa?.currentVisitTypes === 'total_trial') {
          newPeriodType?.forEach((item, index) => {
            visitArray.push(...item?.visits)
          })
        } else {
          newPeriodType?.forEach((item, index) => {
            if (item?.visit_type === props.newSoa?.currentVisitTypes) {
              visitArray.push(...item?.visits)
            }
          })
        }
        let modality_options = getModalityOptionData(modalityChartOrgData,visitArray)
        setModalityChartData(modality_options)  
        
        setCurrentVisitIndex(visitArray)  
      },[props.newSoa?.currentVisitTypes, periodDataDetails,modalityChartOrgData,visits])


      useEffect(() => {
      if(props.newSoa.scenarios){ 
         const scenario = props.newSoa.scenarios && props.newSoa.scenarios.find(s=> s['ts_id'] == localStorage.getItem('ts_id'));
         const eventsConfigure = scenario&&scenario['Schedule of Activities']
         const scenarioTemp = props.newSoa.scenarios[0]
         const eventsConfigureTemp = scenarioTemp&&scenarioTemp['Schedule of Activities']
         const eventsConfigWeeksTemp = eventsConfigureTemp&&eventsConfigureTemp.Weeks
         setSoaOncologyFlag(scenarioTemp?.oncology_flag) 
         props.updateSoaActivities({
          soaOncologyFlag: scenarioTemp?.oncology_flag
         }) 
         if(pageLoading){
          return
         } else {
          if((eventsConfigure && Object.keys(eventsConfigure).length > 0 && eventsConfigure['period_data'] && eventsConfigure['period_data'].length > 0) || props.newSoa?.soaPeriod_data?.length > 0 ) {
            setShowConfigure(false)
          } 
          else {
            setShowConfigure(true)
          }         
         }
        
         setVisitTypeLib(scenarioTemp['visit_type']) 
         
          if(!isSave) {
            if(props.newSoa?.currentVisitTypes === "total_trial") {
              const dismissedEvents = props.newSoa?.totalTrialDismissedActivity;
                if (dismissedEvents.length === 0) {
                  // No activities dismissed, set all insights
                  setInsightEvent(scenario && scenario['soa_insights'] ? scenario['soa_insights'] : []);
                } else {
                  // Activities dismissed, filter insights
                  const filteredInsights = (scenario && scenario['soa_insights'] ? scenario['soa_insights'] : []).filter(insight => 
                    !dismissedEvents.some(dismissed => dismissed.activity === insight.activity)
                  );
                  setInsightEvent(filteredInsights);
                }

            }else {
              // Handle other current visit types
              const currentVisitType = toSentenceCase(props.newSoa?.currentVisitTypes);
              
              const period = props.newSoa?.soaPeriod_data?.find(p => p.period_name === currentVisitType);
              // console.log('period value',period)

              if (period) {

                if (!period.soaDismissedActivity) {
                  period.soaDismissedActivity = [];
                }
                const dismissedActivities = period.soaDismissedActivity;
                if (dismissedActivities?.length === 0) {
                  // No activities dismissed for this period, set all insights for this period
                  
                  setInsightEvent(scenario && scenario['soa_insights'] ? scenario['soa_insights'] : []);
                } else {
                  // Activities dismissed for this period, filter insights for this period
                  const filteredPeriodInsights = (scenario && scenario['soa_insights'] ? scenario['soa_insights'] : []).filter(insight => 
                    !dismissedActivities.some(dismissed => dismissed.activity === insight.activity)
                  );
                  setInsightEvent(filteredPeriodInsights);
                }
              } 

          }

          } else {
            setInsightEvent(scenario&&scenario['soa_insights']? scenario['soa_insights']:[])
          }
            
          
          props.setDisableSaveFinish(props.newSoa.scenarios? true : false)
          if(eventsConfigure != undefined  && eventsConfigure.Weeks != undefined && eventsConfigure.Weeks.length !== 0){
            setHiddeTags(false)
          }
         
          else if(eventsConfigWeeksTemp == undefined && !props.event_numbers){ 
            props.setDisableSaveFinish(true)
          }
          let cost_avg = 0;
          let burden_avg = 0;

          if(props.newSoa&&props.newSoa.therapeutic_area_average != undefined){
              cost_avg = formatCostAvg(props.newSoa&&props.newSoa.therapeutic_area_average.cost_avg, 1000) ?? 0;
              burden_avg = props.newSoa&&props.newSoa.therapeutic_area_average.burden_avg != undefined?
                      Number(props.newSoa&&props.newSoa.therapeutic_area_average.burden_avg.toString().match(/^\d+(?:\.\d{0,2})?/)) : 0;
          }
          
          setModalityOptions(getModalityOptions(scenario&&scenario['modality_option'])) 
          const getStandardEventsLib = async () => {
            if(!localStorage.getItem('trial-id')) return
            var resp = props.memoizedLibraryData; 
            if (resp && resp != "{}") { 
                const response = resp
                ReactDOM.unstable_batchedUpdates(() => {
                  setOrgLabs(response[CATEGORY_LABS])
                  setOrgExamination(response[CATEGORY_PHYSICAL_EXAMINATION])
                  setOrgProcedures(response[CATEGORY_PROCEDURES])
                  setOrgQuestionnaires(response[CATEGORY_QUESTIONNAIRES])
                  setOrgStudyProcedures(response[CATEGORY_STUDY_PROCEDURES])

                  if(eventsConfigure &&Object.keys(eventsConfigure).length > 0 && isEventsAdded(eventsConfigure)){
                    setChartLoading(false);
                  }

                    let periodData, week, visitDetails, notes
                    if(props?.newSoa?.soaPeriod_data?.length == 0) {
                      periodData = eventsConfigureTemp['period_data']
                      setPeriodDataDetails(periodData) 
                    } else {
                      periodData = props?.newSoa?.soaPeriod_data
                      setPeriodDataDetails(periodData) 
                    }
                    if(props.newSoa?.soaVisits?.length == 0) {
                      visitDetails = eventsConfigureTemp.visits
                      setVisits(visitDetails)
                    } else {
                      visitDetails = props.newSoa?.soaVisits
                      setVisits(visitDetails)
                    }
                    
                    if(props?.newSoa?.soaVisitNotesList?.length == 0) {
                      notes = eventsConfigure.visit_notes
                      setVisitNoteList(notes)                    
                    } else {
                      notes = props?.newSoa?.soaVisitNotesList
                      setVisitNoteList(notes)                    
                    }

                    if(props.newSoa.soaWeeks?.length == 0) {
                      week = eventsConfigure?.Weeks
                      setWeeks(week) 
                    } else {
                      week = props.newSoa?.soaWeeks
                      setWeeks(week) 
                    }

                    updateEventHandler(props.newSoa.event_numbers) 
                    const addedLabVal = eventsConfigure !== undefined && props?.newSoa?.soaAddedLabs !== undefined ? removeDuplicates(props?.newSoa?.soaAddedLabs, eventsConfigure[CATEGORY_LABS]?.entities ?? [],response[CATEGORY_LABS]) : props?.newSoa?.soaAddedLabs
                    const addedExamVal = eventsConfigure !== undefined && props?.newSoa?.soaAddedExamination  !== undefined ? removeDuplicates(props?.newSoa?.soaAddedExamination, eventsConfigure[CATEGORY_PHYSICAL_EXAMINATION]?.entities ?? [],response[CATEGORY_PHYSICAL_EXAMINATION]) : props?.newSoa?.soaAddedExamination;
                    const addedQuestionnaireVal = eventsConfigure !== undefined && props?.newSoa?.soaAddedQuestionnaires  !== undefined? removeDuplicates(props?.newSoa?.soaAddedQuestionnaires, eventsConfigure[CATEGORY_QUESTIONNAIRES]?.entities ?? [],response[CATEGORY_QUESTIONNAIRES]) : props?.newSoa?.soaAddedQuestionnaires
                    const addedProcedureVal = eventsConfigure !== undefined && props?.newSoa?.soaAddedProcedures !== undefined ? removeDuplicates(props?.newSoa?.soaAddedProcedures, eventsConfigure[CATEGORY_PROCEDURES]?.entities ?? [],response[CATEGORY_PROCEDURES]) : props?.newSoa?.soaAddedProcedures
                    const addedStudyProcedureVal = eventsConfigure !== undefined && props.newSoa?.soaAddedStudyProcedures !== undefined? removeDuplicates(props?.newSoa?.soaAddedStudyProcedures, eventsConfigure[CATEGORY_STUDY_PROCEDURES]?.entities ?? [],response[CATEGORY_STUDY_PROCEDURES]) : props?.newSoa?.soaAddedStudyProcedures   

                    // const filteredAddedLab = filterDeletedItems(addedLabVal, props.newSoa.soaFilteredLabs)
                    // const filteredAddedExamination = filterDeletedItems(addedExamVal, props?.newSoa?.soaFilteredExamination,)
                    // const filteredAddedQuestionnaire = filterDeletedItems(addedQuestionnaireVal, props?.newSoa?.soaFilteredQuestionnaires)
                    // const filteredAddedProcedure = filterDeletedItems(addedProcedureVal, props?.newSoa?.soaFilteredProcedures)
                    // const filteredAddedStudyProcedure = filterDeletedItems(addedStudyProcedureVal, props?.newSoa?.soaFilteredStudyProcedures)

                    const filteredAddedLab = filterDeletedItems(addedLabVal, props.newSoa.soaFilteredLabs,eventsConfigure["Labs"]?.entities)
                    const filteredAddedExamination = filterDeletedItems(addedExamVal, props?.newSoa?.soaFilteredExamination, eventsConfigure["Physical Examination"]?.entities)
                    const filteredAddedQuestionnaire = filterDeletedItems(addedQuestionnaireVal, props?.newSoa?.soaFilteredQuestionnaires,eventsConfigure["Questionnaires"]?.entities)
                    const filteredAddedProcedure = filterDeletedItems(addedProcedureVal, props?.newSoa?.soaFilteredProcedures,eventsConfigure["Procedures"]?.entities)
                    const filteredAddedStudyProcedure = filterDeletedItems(addedStudyProcedureVal, props?.newSoa?.soaFilteredStudyProcedures,eventsConfigure["Study Procedures"]?.entities)
                    
                    setAddedLabs(filteredAddedLab) 
                    setAddedExamination(filteredAddedExamination)
                    setAddedQuestionnaires(filteredAddedQuestionnaire)
                    setAddedProcedures(filteredAddedProcedure)
                    setAddedStudyProcedures(filteredAddedStudyProcedure)
                    const fLabs = props.newSoa.soaFilteredLabs.length > 0 ? props.newSoa.soaFilteredLabs :  filterLibs(response[CATEGORY_LABS], addedLabVal, FREQUENCY_RANGE_MIN, FREQUENCY_RANGE_MAX)
                    const fExamination = props.newSoa.soaFilteredExamination.length > 0  ? props.newSoa.soaFilteredExamination:  filterLibs(response[CATEGORY_PHYSICAL_EXAMINATION], addedExamVal, FREQUENCY_RANGE_MIN, FREQUENCY_RANGE_MAX)
                    const fProcedures = props.newSoa.soaFilteredProcedures.length > 0 ? props.newSoa.soaFilteredProcedures : filterLibs(response[CATEGORY_PROCEDURES],addedQuestionnaireVal, FREQUENCY_RANGE_MIN, FREQUENCY_RANGE_MAX)
                    const fQuestionnaires = props.newSoa.soaFilteredQuestionnaires.length > 0 ? props.newSoa.soaFilteredQuestionnaires : filterLibs(response[CATEGORY_QUESTIONNAIRES], addedProcedureVal, FREQUENCY_RANGE_MIN, FREQUENCY_RANGE_MAX)
                    const fStudyProcedures = props.newSoa.soaFilteredStudyProcedures.length > 0 ? props.newSoa.soaFilteredStudyProcedures :  filterLibs(response[CATEGORY_STUDY_PROCEDURES], addedStudyProcedureVal, FREQUENCY_RANGE_MIN, FREQUENCY_RANGE_MAX)

                    setFilteredLabs(fLabs)
                    setFilteredExamination(fExamination)
                    setFilteredProcedures(fProcedures)
                    setFilteredQuestionnaires(fQuestionnaires)
                    setFilteredStudyProcedures(fStudyProcedures)
                    setCostData(getCostData(eventsConfigure.CostData))
                   props.updateSoaActivities({  
                    soaFilteredLabs: fLabs,
                    soaFilteredExamination: fExamination,
                    soaFilteredQuestionnaires: fQuestionnaires,
                    soaFilteredProcedures: fProcedures,
                    soaFilteredStudyProcedures: fStudyProcedures,
                    soaAddedLabs: filteredAddedLab,
                    soaAddedExamination: filteredAddedExamination,
                    soaAddedProcedures: filteredAddedProcedure,
                    soaAddedQuestionnaires: filteredAddedQuestionnaire,
                    soaAddedStudyProcedures:  filteredAddedStudyProcedure, 
                    soaPeriod_data: periodData, 
                    soaVisits: visitDetails, 
                    soaVisitNotesList: notes, 
                    soaWeeks: week
                    });
                    setEventCriteria(eventsConfigure) 
                });
            } else {
              
            }
          };
          getStandardEventsLib();
          }
      }, [props.newSoa.scenarios, props.memoizedLibraryData, props.newSoa?.currentVisitTypes, pageLoading, props.newSoa?.soaPeriod_data ]);

      function removeDuplicates(evtItem, addedItem, libraryData) {
        const savedCategory = [...addedItem]
        const libraryCategory = JSON.parse(JSON.stringify(libraryData))
        return [...evtItem, ...addedItem].reduce((unique, item) => {  
          const found = unique.find(obj => obj['Standard Activity'] ===  item['Standard Activity']);  
          const dynamic_endpoints = savedCategory.find(obj => obj['Standard Activity'] ===  item['Standard Activity'])?.endpoint
          // update details of added activities
          const update_Frequency = libraryCategory.find(obj => obj['Standard Activity'] ===  item['Standard Activity'])?.Frequency
          const update_visit_frequency = libraryCategory.find(obj => obj['Standard Activity'] ===  item['Standard Activity'])?.visit_frequency
          const update_cost = libraryCategory.find(obj => obj['Standard Activity'] ===  item['Standard Activity'])?.cost
          if (!found) {
            unique.push({
              ...item, 
              endpoint: dynamic_endpoints ?? item?.endpoint,
              Frequency: update_Frequency ?? item?.Frequency, 
              visit_frequency: update_visit_frequency ?? item?.visit_frequency, 
              cost: update_cost ?? item?.cost
            });  
          }  
          return unique;  
        }, [])
      }
    
      const updateEventHandler = (evt_num) => {
        if(!evt_num || Object.keys(evt_num).length === 0) {
          return;
        }
        const { 
          // ScreeningVisits, 
          // TreatmentVisits, 
          // FollowupVisits, 
          weekNumber
        } = evt_num
        setNumbers({
          // ScreeningVisits: ScreeningVisits,
          // TreatmentVisits: TreatmentVisits,
          // FollowupVisits: FollowupVisits,
          weekNumber:weekNumber
        })
        setEditNumbers({
          // screeningVisitsNumber: ScreeningVisits,
          // treatmentVisitsNumber: TreatmentVisits,
          // followupVisitsNumber: FollowupVisits,
          weekNumber:weekNumber
        })
      //  setShowConfigure(false);
        setWeeks(props.newSoa.soaWeeks) 
       // setVisitNoteList(props.evt_NotesList)
      } 

      function filterLibs(orgLibs, addedEvents, minValue, maxValue){
        let filteredLibs = orgLibs.filter((d) => {
          if( d.Frequency * 100 >= minValue && d.Frequency * 100 <= maxValue){
            var index = addedEvents.findIndex((domain) => d['Standard Activity'] === domain['Standard Activity']);
            if(index > -1){
              return Object.assign(d, {
                selected: true,
                condition: addedEvents[index].condition,
                totalVisit: addedEvents[index].totalVisit})
            } else {
              return Object.assign(d, {selected: false, condition: [], totalVisit: 0})
            }
          }
        })
        return filteredLibs
      }

      var data = [];
for (var i = 0; i < 7; i++) {
    var maxBurden = Math.floor(Math.random() * (400 - 200 + 1)) + 200;
    var medianBurden = Math.floor(Math.random() * (maxBurden - 200 + 1)) + 200;
    data.push([i, maxBurden, medianBurden]); 
}
    
      const handleEventChange = (tmpWeeks) =>{
        if(tmpWeeks != undefined && tmpWeeks.length > 0){
          setWeeks(tmpWeeks)
        }
      }
    
      const statisticsPerVisit = (categories,idx)=>{
        //statistics of each column
        const modalityCollection={}
        const modalitySummary={}
        const columnConditionCollection = []
        if(categories[CATEGORY_LABS]?.length>0){
          categories[CATEGORY_LABS].forEach( ele=>{
            columnConditionCollection.push( ele.condition[idx])
          })
        }
        if(categories[CATEGORY_PHYSICAL_EXAMINATION]?.length>0){
          categories[CATEGORY_PHYSICAL_EXAMINATION].forEach( ele=>{
            columnConditionCollection.push( ele.condition[idx])
          })
    
        }
        if(categories[CATEGORY_PROCEDURES]?.length>0){
          categories[CATEGORY_PROCEDURES].forEach( ele=>{
            columnConditionCollection.push( ele.condition[idx])
          })
    
        }
        if(categories[CATEGORY_QUESTIONNAIRES]?.length>0){
          categories[CATEGORY_QUESTIONNAIRES].forEach( ele=>{
            columnConditionCollection.push( ele.condition[idx])
          })
        }
        if(categories[CATEGORY_STUDY_PROCEDURES]?.length>0){
          categories[CATEGORY_STUDY_PROCEDURES].forEach( ele=>{
            columnConditionCollection.push( ele.condition[idx])
          })
        }
    
        columnConditionCollection.filter(element=>element&&element.modality&&element.modality!=="")
        .forEach( element=>{
        if( Object.keys(modalityCollection).indexOf(element.modality.toString())<0 ){
          modalityCollection[element.modality.toString()]=[element]
        }else{
          modalityCollection[element.modality.toString()].push(element)
        }})
        modalityOptions.forEach( option=>{
         if(option.key&&option.key!==""){
          if(Object.keys(modalityCollection).indexOf(option.key.toString())==-1){
            modalitySummary[option.name]=0
          }else{
            modalitySummary[option.name]=modalityCollection[option.key.toString()].length
          }
         }
        })
        return modalitySummary
      }
      // useEffect(()=>{
      //   const categories={
      //     [CATEGORY_LABS]:addedLabs,
      //     [CATEGORY_PHYSICAL_EXAMINATION]:addedExamination,
      //     [CATEGORY_PROCEDURES]:addedProcedures,
      //     [CATEGORY_QUESTIONNAIRES]:addedQuestionnaires,
      //     [CATEGORY_STUDY_PROCEDURES]:addedStudyProcedures,
      //   }
      //   // getModalitySeriesData(categories)
      //   // triggerChartFetch()
    
      // },[visits,addedLabs,addedExamination,addedProcedures,addedQuestionnaires,addedStudyProcedures]) 
    
      // const getModalitySeriesData = (categories) =>{
      //   const modalitySeries = []
      //   const visitStacks=visits.map( (ele,idx)=>{
      //     return statisticsPerVisit(categories,idx)
      //   })
      //   if(visitStacks.filter(v=>v!==undefined).length==0) return
      //   modalityOptions.forEach((element,idx)=>{
      //     const data = visitStacks.map( v=>{
      //       return v[element.name]
      //     })
      //     modalitySeries.push({
      //       name: element.name,
      //       type: 'bar',
      //       stack: 'total',
      //       emphasis: {
      //         focus: 'series'
      //       },
      //       data,
      //       color:element.color
      //     })
      //   })
      //  // setModalityChartData(modalitySeries)
      // }

      
      const [saveCostChart, setSaveCostChart] = useState(1)
      // useEffect(() => {
      //   if(!periodDataDetails) return
      //   // const _visits = periodDataDetails?.map(item => item?.visits).flat();  
      //   // const _visit_notes = periodDataDetails?.map(item => item?.visit_notes).flat();
      //   const _weeks = periodDataDetails?.map(item => item?.weeks).flat();
      //   // setVisits(_visits)
      //   setWeeks(_weeks)
      //   // props.updateSoaActivities({ 
      //   //   // soaVisits: _visits,
      //   //   soaWeeks: _weeks 
      //   // })        
      //   // setVisitNoteList(_visit_notes)
      //   // props.updateSoaActivities({ soaVisitNotesList: _visit_notes})
      // }, [periodDataDetails])

      useEffect(() => {
        if(!periodDataDetails) return
        const _visit_notes = periodDataDetails?.map(item => item?.visit_notes).flat();
        setVisitNoteList(_visit_notes)
        props.updateSoaActivities({ soaVisitNotesList: _visit_notes})
      }, [periodDataDetails])

      const periodDataUpdateHandler = (data) => {
        setPeriodDataDetails(data)
        props.updateSoaActivities({
          soaPeriod_data: data,
        });
      }

      const findItem = (condition, visit) => condition.find( z => visit == z.visits)

      const getCondition = (category, original) => {
        let tmpCategory = [category].slice(0)[0]; 

        tmpCategory.forEach (con => {
          const tempCondition = JSON.parse(JSON.stringify(con.condition))
          let tmpCat = original.map( k => ((
            { 
              visits:k, 
              period_id: findItem(tempCondition, k)?.period_id,
              modality:  findItem(tempCondition, k)?.modality,
              [soaOncologyFlag?'days':'weeks']: findItem(tempCondition, k)?.weeks,
          })))
          con.condition = tmpCat.map( (k, idx) => (({...k, visits: idx+1 })));
          con.totalVisit = tmpCat.filter(c => c.modality && c.modality!=="").length
        })
        return tmpCategory;
      }

      // Create button when Configure schedule of activities table
      const handleCloseConfigure = async (data, detail_data) => { 
        setPeriodDataDetails(data)
        setShowConfigure(false)
        const _visits = data?.map(item => item?.visits).flat();  
        const _visit_notes = data?.map(item => item?.visit_notes).flat();
        const _weeks = data?.map(item => item?.weeks).flat();
        setVisits(_visits)
        setWeeks(_weeks)
        setVisitNoteList(_visit_notes)

        const prevVisits = detail_data.map(k => k.visits).flat()
        let tmpLabs = getCondition(props.newSoa.soaAddedLabs, prevVisits)
        let tmpExamination = getCondition(props.newSoa.soaAddedExamination, prevVisits)
        let tmpProcedures = getCondition(props.newSoa.soaAddedProcedures, prevVisits)
        let tmpQuestionnaire =getCondition(props.newSoa.soaAddedQuestionnaires, prevVisits)
        let tmpStudyProcedures =  getCondition(props.newSoa.soaAddedStudyProcedures, prevVisits)

        setAddedLabs(tmpLabs)
        setAddedExamination(tmpExamination)
        setAddedQuestionnaires(tmpQuestionnaire)
        setAddedProcedures(tmpProcedures)
        setAddedStudyProcedures(tmpStudyProcedures)
        props.updateSoaActivities({ 
          soaVisitNotesList: _visit_notes, 
          soaVisits: _visits, 
          soaPeriod_data: data, 
          soaAddedLabs: tmpLabs,
          soaAddedExamination: tmpExamination,
          soaAddedProcedures: tmpProcedures,
          soaAddedQuestionnaires: tmpQuestionnaire,
          soaAddedStudyProcedures: tmpStudyProcedures,
          totalTrialDismissedActivity:[]
          }) 
      }

      const saveEvents = async (scheduleOfEvents) =>{
        if(submitType === 1){
          props.handleGoBack(Object.assign(scheduleOfEvents,{
            'TotalCost': eventCriteria.TotalCost,
            'CostRate': eventCriteria.CostRate,
            'CostData': costData,
            // 'BurdenData': burdenData,
            // 'BurdenXAxis': burdenXAxis,
            'Finished': eventCriteria.Finished,
            'WeekNumber': scheduleOfEvents.Weeks[scheduleOfEvents.Weeks.length-1]
          }))
    
          return;
        }
        setWeeks(scheduleOfEvents.Weeks)
        setVisits(scheduleOfEvents?.visits.map((c,i) => c = i + 1))
        setPeriodDataDetails(scheduleOfEvents.period_data)
        let tempEditNumber = {
          // 'screeningVisitsNumber': scheduleOfEvents.ScreeningVisits,
          // 'treatmentVisitsNumber': scheduleOfEvents.TreatmentVisits,
          // 'followupVisitsNumber': scheduleOfEvents.FollowupVisits,
          'weekNumber': scheduleOfEvents.WeekNumber
        }
        let tempPreviousEditNumber = {
          // 'ScreeningVisits': scheduleOfEvents.ScreeningVisits,
          // 'TreatmentVisits': scheduleOfEvents.TreatmentVisits,
          // 'FollowupVisits': scheduleOfEvents.FollowupVisits,
          'weekNumber': scheduleOfEvents.WeekNumber
        }
        setEditNumbers(tempEditNumber)
        setPreviousCategoryVisits(tempPreviousEditNumber)
        // const categories={
        //   [CATEGORY_LABS]:scheduleOfEvents[CATEGORY_LABS].entities,
        //   [CATEGORY_PHYSICAL_EXAMINATION]:scheduleOfEvents[CATEGORY_PHYSICAL_EXAMINATION].entities,
        //   [CATEGORY_PROCEDURES]:scheduleOfEvents[CATEGORY_PROCEDURES].entities,
        //   [CATEGORY_QUESTIONNAIRES]:scheduleOfEvents[CATEGORY_QUESTIONNAIRES].entities,
        //   [CATEGORY_STUDY_PROCEDURES]:scheduleOfEvents[CATEGORY_STUDY_PROCEDURES].entities,
        // }
        setAddedLabs(scheduleOfEvents[CATEGORY_LABS].entities.sort( (a, b) => a['Standard Activity'] < b['Standard Activity'] ? -1 : 1))
        setAddedExamination(scheduleOfEvents[CATEGORY_PHYSICAL_EXAMINATION].entities.sort( (a, b) => a['Standard Activity'] < b['Standard Activity'] ? -1 : 1))
        setAddedQuestionnaires(scheduleOfEvents[CATEGORY_QUESTIONNAIRES].entities.sort( (a, b) => a['Standard Activity'] < b['Standard Activity'] ? -1 : 1))
        setAddedProcedures(scheduleOfEvents[CATEGORY_PROCEDURES].entities.sort( (a, b) => a['Standard Activity'] < b['Standard Activity'] ? -1 : 1))
        setAddedStudyProcedures(scheduleOfEvents[CATEGORY_STUDY_PROCEDURES].entities.sort( (a, b) => a['Standard Activity'] < b['Standard Activity'] ? -1 : 1))
        // getModalitySeriesData(categories)
        let costList ;
        let burdenList
        if(props.newSoa&&props.newSoa.therapeutic_area_average != undefined && props.newSoa&&props.newSoa.therapeutic_area_average.length > 0){
            costList = [props.newSoa&&props.newSoa.therapeutic_area_average.cost_limit_lower_quartile, props.newSoa&&props.newSoa.therapeutic_area_average.cost_limit_upper_quartile]
            burdenList = [props.newSoa&&props.newSoa.therapeutic_area_average.pb_limit_lower_quartile, props.newSoa&&props.newSoa.therapeutic_area_average.pb_limit_upper_quartile]
        }else{
            costList = [0,0];
            burdenList = [0,0];
        }
    
        let currentScenario = props.newSoa.scenarios && props.newSoa.scenarios.find(s=> s['ts_id'] == localStorage.getItem('ts_id'));
        // let soa_dismiss_list = props.newSoa?.soaDismissEvent||[]        
        let soa_dismiss_list = dismissEvent||[]      
        // scheduleOfEvents["period_data"] = periodDataDetails
        // scheduleOfEvents["visits"] = scheduleOfEvents?.visits.map((c,i) => c = i + 1)
        // scheduleOfEvents["visit_notes"] = visitNoteList
        setIsSave(true)
        const payload = {
          "trial_uuid": trialUUID,
          "user_name":  getEmail(),
          "ts_id": localStorage.getItem('ts_id'),
          "oncology_flag": scenario['oncology_flag'],
          "soa": scheduleOfEvents,
          // "editNumbers": tempEditNumber,

          "cost_limits": costList,
          "burden_limits": burdenList,
          "soa_dismiss_list":soa_dismiss_list,
        }
        const resp = await update_patient_burden(payload)
       
        if (resp && Object.keys(resp).length > 1) {
          triggerChartFetch()
          setDismissEvent([])
          props.updateSoaActivities({soaDismissEvent: []})
          // const response = resp
          // Call get_trial_soa to get the updated soa
          // setPageLoading(true)
          const response = await getTrialSoa(trialUUID, localStorage.getItem('ts_id'), getEmail(),props.newSoa?.currentVisitTypes); 
          
          if (response && Object.keys(response).length > 1) {
            props.createSoa(response)
            message.success('Save successfully') 
          } else {
            message.error('Failed to fetch SOA data.')
            return
          }  
          // setPageLoading(false)
          const soa = response?.scenarios&&response?.scenarios[0]['Schedule of Activities']
          // const soa = response['soa']
          let finalCost = 0;
          soa?.CostData?.forEach(item => {
            finalCost += item.value;
          });
          setCostData(soa?.CostData?.sort((a, b) => {
            if (a.name < b.name) {
              return -1;
            }
          }))
          // setBurdenData(soa.BurdenData)
          // setBurdenXAxis(soa.BurdenXAxis)
          let tempNumber = {
            // 'ScreeningVisits': scheduleOfEvents.ScreeningVisits,
            // 'TreatmentVisits': scheduleOfEvents.TreatmentVisits,
            // 'FollowupVisits': scheduleOfEvents.FollowupVisits,
            'weekNumber': scheduleOfEvents.WeekNumber
          }
          setNumbers(tempNumber)
          let tempTrialSOA = props.newSoa
          let tempScenario = tempTrialSOA.scenarios.find(s=> s['ts_id'] == localStorage.getItem('ts_id'));
          tempScenario["Schedule of Activities"] = soa
          currentScenario['Schedule of Activities'] = soa
          props.setScenario(currentScenario)
          // Update soa_insights data
          currentScenario['soa_insights'] = response?.scenarios&&response?.scenarios[0]['soa_insights']
          setInsightEvent(response?.scenarios&&response?.scenarios[0]['soa_insights'])
          props.updateSoaActivities({soaInsightEvent: response?.scenarios&&response?.scenarios[0]['soa_insights']})
          // const _visit_notes = soa?.period_data?.map(item => item?.visit_notes).flat();
          // setVisitNoteList(_visit_notes)          
          props.createSoa(tempTrialSOA)
          setSaveCostChart(Math.floor(Math.random() * 1000) + 1)
          // message.success('Save successfully') 
          if(submitType == 2){
            props.updateSoaActivities(initialSoa)
          }
          if(submitType == 3){
            viewImpactSummary()
          }else if(submitType != 0){
            props.updateEndpoints(initialEndpoint)
            props.history.push({pathname: '/trials', state: {trial_id: props.newSoa&&props.newSoa['trial_uuid']}})
            localStorage.setItem('activeTabKey', JSON.stringify('0'));
            localStorage.setItem('soaPresetActiveTabKey', null)
            localStorage.setItem('collapseCharts', JSON.stringify({"endpointCollapse" : ['1'],
                                                "inclusionCollapse" : ['1'],
                                                "exclusionCollapse" : ['1'],
                                                "soaCollapse" : ['1']
                                                }));
          }
//           setSoaActiveKey(['1'])
        }else{
            message.error('Failed to save')
        }

      }
    
      function roundFun(value, n) {
          return Math.round(value*Math.pow(10,n))/Math.pow(10,n);
      }
    
      function formatCostAvg(totalCost, divisor){
        if(totalCost == undefined || totalCost === 0){
          return 0
        } else {
          let avg = Math.ceil(totalCost/divisor*1000)
          return roundFun(avg/1000, 2)
        }
      }
    
      const handleEvent = (item) => { 
        switch(item.Categories.trim()){
          case "Labs":
            let index = filteredLabs.findIndex((d) => item['Standard Activity'] == d['Standard Activity'])
            let rFilterLab= props?.newSoa?.soaFilteredLabs.length > 0 ? [...props?.newSoa?.soaFilteredLabs] : [...filteredLabs]
            let newData = [...filteredLabs]
            const newSelectedData = [...addedLabs]
    
            if(item.selected){ 
              for (let key in item) {
                if (key == "endpoint") {
                   delete item[key];
                }
             }  
              newData.splice(index, 1, { ...item, ...{selected: false, condition: [], totalVisit: 0, endpoint: newData[index].endpoint, deleted: true}});
              rFilterLab.splice(index, 1, { ...item, ...{selected: false, condition: [], totalVisit: 0,  endpoint: newData[index].endpoint, deleted: true}}); 
              let selectedIndex = addedLabs.findIndex((d) => item['Standard Activity'] == d['Standard Activity'])
              newSelectedData.splice(selectedIndex, 1)
            } else {
              newData.splice(index, 1, { ...item, ...{selected: true, endpoint: newData[index].endpoint}});
              newSelectedData.push(Object.assign(item, {selected: true, endpoint: newData[index].endpoint}))
            }
            setFilteredLabs(newData)
            setAddedLabs(newSelectedData)
            if(props.newSoa.soaAddedLabs.length > 0) {
              props.updateSoaActivities({
                soaAddedLabs: newSelectedData, 
                soaFilteredLabs: rFilterLab
              });
            }  
            break;
    
          case "Physical Examination":
            let index2 = filteredExamination.findIndex((d) => item['Standard Activity'] == d['Standard Activity'])
            const newData2 = [...filteredExamination]
            const newSelectedData2 = [...addedExamination]
            let rFilterExamination = props?.newSoa?.soaFilteredExamination.length > 0 ? [...props?.newSoa?.soaFilteredExamination] : [...filteredExamination]
            if(item.selected){
              for (let key in item) {
                if (key == "endpoint") {
                   delete item[key];
                }
             }
              newData2.splice(index2, 1, { ...item, ...{selected: false, condition: [], totalVisit: 0, endpoint: newData2[index2].endpoint, deleted: true}});
              rFilterExamination.splice(index2, 1, { ...item, ...{selected: false, condition: [], totalVisit: 0, endpoint: newData2[index2].endpoint, deleted: true}});
              let selectedIndex = addedExamination.findIndex((d) => item['Standard Activity'] == d['Standard Activity'])
              newSelectedData2.splice(selectedIndex, 1)
            } else {
              newData2.splice(index2, 1, { ...item, ...{selected: true, endpoint: newData2[index2].endpoint}});
              newSelectedData2.push(Object.assign(item, {selected: true, endpoint: newData2[index2].endpoint}))
            }
            setFilteredExamination(newData2)
            setAddedExamination(newSelectedData2) 
            if(props.newSoa.soaAddedExamination.length > 0) {
              props.updateSoaActivities({
                soaAddedExamination: newSelectedData2, 
                soaFilteredExamination: rFilterExamination
              });
            } 
            break;
    
          case "Procedures":
            let index3 = filteredProcedures.findIndex((d) => item['Standard Activity'] == d['Standard Activity'])
            const newData3 = [...filteredProcedures]
            const newSelectedData3 = [...addedProcedures]
            let rFilterProcedure = props?.newSoa?.soaFilteredProcedures.length > 0 ? [...props?.newSoa?.soaFilteredProcedures] :  [...filteredProcedures]
            if(item.selected){
              for (let key in item) {
                if (key == "endpoint") {
                   delete item[key];
                }
             }
              newData3.splice(index3, 1, { ...item, ...{selected: false, condition: [], totalVisit: 0, endpoint: newData3[index3].endpoint, deleted: true }});
              rFilterProcedure.splice(index3, 1, { ...item, ...{selected: false, condition: [], totalVisit: 0, endpoint: newData3[index3].endpoint, deleted: true }});
              let selectedIndex = addedProcedures.findIndex((d) => item['Standard Activity'] == d['Standard Activity'])
              newSelectedData3.splice(selectedIndex, 1)
            } else {
              newData3.splice(index3, 1, { ...item, ...{selected: true, endpoint: newData3[index3].endpoint}});
              newSelectedData3.push(Object.assign(item, {selected: true, endpoint: newData3[index3].endpoint}))
            }
            setFilteredProcedures(newData3)
            setAddedProcedures(newSelectedData3)
            if(props.newSoa.soaAddedProcedures.length > 0) {
              props.updateSoaActivities({
                soaAddedProcedures: newSelectedData3, 
                soaFilteredProcedures: rFilterProcedure
              });
            }   
            break;
    
          case "Questionnaires":
            let index4 = filteredQuestionnaires.findIndex((d) => item['Standard Activity'] == d['Standard Activity'])
            const newData4 = [...filteredQuestionnaires]
            const newSelectedData4 = [...addedQuestionnaires]
            let rFilterQuestionnaire = props?.newSoa?.soaFilteredQuestionnaires?.length > 0 ? [...props?.newSoa?.soaFilteredQuestionnaires] : [...filteredQuestionnaires]
            if(item.selected){
              for (let key in item) {
                if (key == "endpoint") {
                   delete item[key];
                }
             }
              newData4.splice(index4, 1, { ...item, ...{selected: false, condition: [], totalVisit: 0, endpoint: newData4[index4].endpoint, deleted: true}});
              rFilterQuestionnaire.splice(index4, 1, { ...item, ...{selected: false, condition: [], totalVisit: 0, endpoint: newData4[index4].endpoint, deleted: true}});
              let selectedIndex = addedQuestionnaires.findIndex((d) => item['Standard Activity'] == d['Standard Activity'])
              newSelectedData4.splice(selectedIndex, 1)
            } else {
              newData4.splice(index4, 1, { ...item, ...{selected: true, endpoint: newData4[index4].endpoint}});
              newSelectedData4.push(Object.assign(item, {selected: true, endpoint: newData4[index4].endpoint}))
            }
            setFilteredQuestionnaires(newData4)
            setAddedQuestionnaires(newSelectedData4)
          if(props.newSoa.soaAddedQuestionnaires.length > 0) {
            props.updateSoaActivities({
              soaAddedQuestionnaires: newSelectedData4, 
              soaFilteredQuestionnaires: rFilterQuestionnaire
            });
          }  
            break;
          case "Study Procedures":
            let index5 = filteredStudyProcedures.findIndex((d) => item['Standard Activity'] == d['Standard Activity'])
            const newData5 = [...filteredStudyProcedures]
            const newSelectedData5 = [...addedStudyProcedures]
            let rFilterStudy = props?.newSoa?.soaFilteredStudyProcedures?.length > 0 ? [...props?.newSoa?.soaFilteredStudyProcedures] : [...filteredStudyProcedures];

            if(item.selected){
              for (let key in item) {
                if (key == "endpoint") {
                   delete item[key];
                }
             }
              newData5.splice(index5, 1, { ...item, ...{selected: false, condition: [], totalVisit: 0, endpoint: newData5[index5].endpoint, deleted: true}});
              rFilterStudy.splice(index5, 1, { ...item, ...{selected: false, condition: [], totalVisit: 0, endpoint: newData5[index5].endpoint, deleted: true}});
              let selectedIndex = addedStudyProcedures.findIndex((d) => item['Standard Activity'] == d['Standard Activity'])
              newSelectedData5.splice(selectedIndex, 1)
            } else {
              newData5.splice(index5, 1, { ...item, ...{selected: true, endpoint: newData5[index5].endpoint}});
              newSelectedData5.push(Object.assign(item, {selected: true, endpoint: newData5[index5].endpoint}))
            }
            setFilteredStudyProcedures(newData5)
            setAddedStudyProcedures(newSelectedData5)
            if(props.newSoa.soaAddedStudyProcedures.length > 0) {
              props.updateSoaActivities({
                soaAddedStudyProcedures: newSelectedData5, 
                soaFilteredStudyProcedures: rFilterStudy
              });
            } 
            break;
          default: break;
        }
        handleEventChange([])
      }
    
      const showConfigureModal = () =>{
        setShowConfigure(true)
      }
    
      const [windowResize, setWindowResize] = useState(true)
    
      useEffect(() => {
        if(showConfigure) {
          setWindowResize(false)
        } else {
          setWindowResize(true)
        }  
      }, [showConfigure])
    
      // const handleOk = () => {
      //   if(!validateScreeningVisit(numbers.ScreeningVisits) || !validateTreatmentVisit(numbers.TreatmentVisits) || !validateFollowUpVisit(numbers.FollowupVisits) || !validateWeek(numbers.weekNumber)){
      //     return
      //   }
      //   let final_visit_number = numbers.ScreeningVisits + numbers.TreatmentVisits + numbers.FollowupVisits; 
      //   setShowConfigure(false)
      //   setHiddeTags(false)
      //   props.updateSoaActivities({event_numbers: numbers})  
      //   let weeksArr = [];
      //   // if(resetWeeks){
      //     let tempBurdenXAxis = []
      //     for(var num = 1; num <= final_visit_number; num++){
      //       tempBurdenXAxis.push(num)
      //     }
      //     setBurdenXAxis(tempBurdenXAxis)
      //     //Re-generate whole weeks when no change in SOA
      //     if (numbers.weekNumber < final_visit_number){
      //       for(var num = 0; num < final_visit_number - numbers.weekNumber + 1; num ++){
      //         weeksArr.push(1)
      //       }
      //       var size = weeksArr.length
      //       for(var num = 1; num <= final_visit_number - size; num ++){
      //         weeksArr.push(num + 1)
      //       }
      //     } else if (numbers.weekNumber == final_visit_number){
      //       for (let num = 1; num <= numbers.weekNumber; num ++){
      //         weeksArr.push(num)
      //       }
      //     } else {
      //       weeksArr.push(1)
      //       if (final_visit_number > 1){
      //         const a = (numbers.weekNumber - 1) % (final_visit_number - 1)
      //         const b = Math.floor((numbers.weekNumber - 1)/(final_visit_number - 1))
      //         let temp_num = 1
      //         for (let num = 1; num < final_visit_number; num ++ ) {
      //           if (final_visit_number - num > a) {
      //             weeksArr.push(temp_num + b)
      //             temp_num += b
      //           } else {
      //             weeksArr.push(temp_num + b + 1)
      //             temp_num += b + 1
      //           }
      //         }
      //       }
      //     }
      //   // } else {
      //   //   //Keep weeks options as much as possible after SOA changed
      //   //   let week = 0;
      //   //   if(numbers.visitNumber > editNumbers.visitNumber && numbers.weekNumber > weeks[weeks.length - 1]){
      //   //     week = Math.floor((numbers.weekNumber - weeks[weeks.length - 1]) / (numbers.visitNumber - editNumbers.visitNumber));
      //   //   }
      //   //   let sum = 0;
      //   //   for (var i = 1; i <= numbers.visitNumber; i++) {
      //   //     if(weeks.length >= i){
      //   //       weeksArr.push(weeks[i-1])
      //   //       sum = weeks[i-1]
      //   //     } else {
      //   //       sum += week;
      //   //       if (sum > numbers.weekNumber || i === numbers.visitNumber) sum = numbers.weekNumber;
      //   //       weeksArr.push(sum)
      //   //     }
      //   //   }
      //   // }
      //  setWeeks(weeksArr)
      //   props.updateSoaActivities({soaWeeks: weeksArr}) 
      //   setEditNumbers({
      //     // screeningVisitsNumber: numbers.ScreeningVisits,
      //     // treatmentVisitsNumber:  numbers.TreatmentVisits,
      //     // followupVisitsNumber: numbers.FollowupVisits,
      //     weekNumber: numbers.weekNumber
      //   })
      //   setIsUpdateMode(true);
      //   setEventCriteria({
      //     'Finished' : false
      //   })
    
      //   updateVisitNotes(numbers, weeksArr);
      // }
    
      // const  handleResetNotes = (idx, isDelete, isAdd) => { 
      //   // let tempPreviousEditNumber = {
      //   //   'ScreeningVisits': obj?.evtScreeningVisitsNumber,
      //   //   'TreatmentVisits': obj?.evtTreatmentVisitsNumber,
      //   //   'FollowupVisits': obj?.evtFollowupVisitsNumber,
      //   //   'weekNumber': obj?.evtWeekNumber
      //   // }
      //   // setWeeks(newWeeks)
      //   if(isDelete) {
      //     props.updateSoaActivities({ soaVisitNotesList: DeleteVisitItem(idx) })
      //   } else if(isAdd){
      //     props.updateSoaActivities({ soaVisitNotesList: AddVisitItem(idx) })
      //   }
    
    
      // }
    
    
      // const DeleteVisitItem = (idx) => {
      //   let notes = [...visitNoteList];
      //   notes.splice(idx, 1)
      //   // setPreviousCategoryVisits(tempPreviousEditNumber)
      //   return notes;
      // }
    
      // const AddVisitItem = (idx) => {
      //   let notes = [...visitNoteList];
      //   let toBeArray =  Array.from({ length: 1 }, (v, i) => i).map((k, i) => (''))
      //   notes.splice(idx+1, 0, ...toBeArray)
      //   // setPreviousCategoryVisits(tempPreviousEditNumber)
      //   return notes;
      // }
    
      // const handleScreeningVisits = async(numbers, Obj,weeksArr) => {
      //   let{ notes, categories} = Obj;
      //   if(numbers?.ScreeningVisits > categories.ScreeningVisits) {
      //     if(numbers?.ScreeningVisits - categories.ScreeningVisits >= 1) {
      //     let length = numbers?.ScreeningVisits - categories.ScreeningVisits;
      //     let m_arr =  Array.from({ length: length }, (v, i) => i).map((k, i) => categories.ScreeningVisits + k)
      //      notes = addNotesCondition( m_arr, weeksArr, notes);
      //     }
      //   } else {
      //     let length = categories.ScreeningVisits - numbers?.ScreeningVisits ;
      //     let m_arr =  Array.from({ length: length }, (v, i) => i).map((k, i) => numbers?.ScreeningVisits + k )
      //     notes = deleteNotesCondition( m_arr, weeksArr, notes)
      //   }
      //   categories = {
      //     'ScreeningVisits': numbers?.ScreeningVisits,
      //     'TreatmentVisits': categories?.TreatmentVisits,
      //     'FollowupVisits': categories?.FollowupVisits,
      //     'weekNumber': numbers?.WeekNumber
      //   }
      //   return {
      //     notes,
      //     categories
      //   }
      // }
    
      // const handleTreatmentVisits = async(numbers, Obj,weeksArr) => {
      //   let{ notes, categories} = Obj
      //   if(numbers.TreatmentVisits > categories.TreatmentVisits) {
      //     if(numbers.TreatmentVisits - categories.TreatmentVisits >= 1) {
      //       let length = numbers?.TreatmentVisits - categories.TreatmentVisits;
      //       let m_arr =  Array.from({ length: length }, (v, i) => i).map((k, i) => categories.ScreeningVisits + categories.TreatmentVisits + k)
      //       notes = addNotesCondition( m_arr, weeksArr, notes);
      //     }
      //   } else {
      //     let length = categories.TreatmentVisits - numbers?.TreatmentVisits ;
      //     let m_arr =  Array.from({ length: length }, (v, i) => i).map((k, i) => numbers?.ScreeningVisits + numbers?.TreatmentVisits + k )
      //     notes = deleteNotesCondition( m_arr, weeksArr, notes)
      //   }
      //   categories = {
      //     'ScreeningVisits': numbers?.ScreeningVisits,
      //     'TreatmentVisits': numbers?.TreatmentVisits,
      //     'FollowupVisits': categories?.FollowupVisits,
      //     'weekNumber': numbers?.WeekNumber
      //   }
      //   return {
      //     notes,
      //     categories
      //   }
      // }
    
      // const handleFollowUpVisits = async(numbers, Obj,weeksArr) => {
      //   let{ notes, categories} = Obj
      //   if(numbers.FollowupVisits > categories.FollowupVisits) {
      //     if(numbers.FollowupVisits - categories.FollowupVisits >= 1) {
      //       let length = numbers?.FollowupVisits - categories.FollowupVisits;
      //       let m_arr =  Array.from({ length: length }, (v, i) => i).map((k, i) => categories.ScreeningVisits + categories.TreatmentVisits + categories.FollowupVisits + k);
      //       notes = addNotesCondition( m_arr, weeksArr, notes);
      //   }
      //   } else {
      //      let length = categories.FollowupVisits - numbers?.FollowupVisits ;
      //     let m_arr =  Array.from({ length: length }, (v, i) => i).map((k, i) => numbers?.ScreeningVisits + numbers?.TreatmentVisits + numbers?.FollowupVisits + k )
      //     notes = deleteNotesCondition( m_arr, weeksArr, notes)
      //   }
      //   categories = {
      //     'ScreeningVisits': numbers?.ScreeningVisits,
      //     'TreatmentVisits': numbers?.TreatmentVisits,
      //     'FollowupVisits': numbers?.FollowupVisits,
      //     'weekNumber': numbers?.WeekNumber
      //   }
      //   return {
      //     notes,
      //     categories
      //   }
      // }
    
      // const addNotesCondition = ( m_arr, weeks, visitsNotes) => {
      //   let notes = [...visitsNotes];
      //   let toBeArray =  Array.from({ length: m_arr.length }, (v, i) => i).map((k, i) => ({visit_notes: '', weeks : weeks[m_arr[k]], visit: m_arr[k] + 1 }))
      //   let visitNotes = notes.map(k => k?.visit_notes)
      //   visitNotes.splice(m_arr[0], 0, ...toBeArray.map(k => k?.visit_notes))
      //   notes.splice(m_arr[0], 0, ...toBeArray)
      //   notes = notes.map((k, i) => ({...k, visit_notes: visitNotes[i], weeks: weeks[i], visit: i + 1}))
      //   return notes;
      // }
      useEffect(() => {
        setVisitNoteList(props.newSoa.soaVisitNotesList)        
      }, [props.newSoa.soaVisitNotesList])
    
      // const updateVisitNotes = async (numbers,weeksArr) => {
      //   let notesByVisitsObj = {
      //     notes: [...visitNoteList],
      //     categories: {...prevCategoryVisists}
      //     }
      //   notesByVisitsObj = await handleScreeningVisits(numbers, notesByVisitsObj, weeksArr)
      //   notesByVisitsObj = await handleTreatmentVisits(numbers, notesByVisitsObj, weeksArr)
      //   notesByVisitsObj = await handleFollowUpVisits(numbers, notesByVisitsObj,  weeksArr)  
      //   props.updateSoaActivities({ soaVisitNotesList: notesByVisitsObj.notes })
      //   setPreviousCategoryVisits(notesByVisitsObj.categories);
      // }
    
      // let getVisitData = (z) => {
      //   return visitNoteList?.find((k, i) => k?.visit == visits[z])?.visit_notes;
      // }
    
      //   useEffect(() => {
      //   if(visits?.length == 0 || weeks?.length == 0 || weeks?.length !== visits?.length) return;
      //     let n_visists = visits?.map((k, i) => ({visit_notes: getVisitData(i) ??  '', weeks:weeks[i], visit: visits[i] }));
      //     let arr = n_visists?.length > 0 ? n_visists : []
      //     setVisitNoteList(arr)
      //     props.updateSoaActivities({ soaVisitNotesList: arr})
      // }, [visits, weeks]);

      // useEffect(() => {
      //   if(weeks?.length > 0) {
      //     props.updateSoaActivities({soaWeeks :  weeks})
      //   }
      // }, [weeks]);

      // useEffect(() => {
      //   if(visits?.length > 0) {
      //     props.updateSoaActivities({soaVisits :  visits})
      //   }
      // }, [visits]);
    
    
      // const deleteNotesCondition = ( m_arr, weeks, visitsNotes) => {
      //   if(visitNoteList.length == 0) return
      //   let notes = [...visitsNotes];
      //   let visitNotes = notes.map(k => k?.visit_notes)
      //   notes.splice(m_arr[0], m_arr.length)
      //   visitNotes.splice(m_arr[0], m_arr.length)
      //   notes = notes.map((k, i) => ({...k, visit_notes: visitNotes[i], weeks: weeks[i], visit: i + 1}))
      //   return notes;
      // }
      const [currentIndex, setCurrentIndex] = useState(3);

      const handleInsightChange = (orgCategoryData, filteredCategoryData, addedCategoryData, item) => {
        let tempDetailCategoryData
        let indexDetailCategoryData
        indexDetailCategoryData = orgCategoryData.findIndex((d) => item['activity'] == d['Standard Activity'])
        indexDetailCategoryData > -1? tempDetailCategoryData = orgCategoryData[indexDetailCategoryData] : []
        let detailCategoryData = JSON.parse(JSON.stringify(tempDetailCategoryData))
        detailCategoryData['Frequency'] = item['frequency']        
        let index = filteredCategoryData.findIndex((d) => item['activity'] == d['Standard Activity'])
        let newData = [...filteredCategoryData]
        const newSelectedData = [...addedCategoryData]
        let selection;
        if(item.action === "REMOVE"){
          newData.splice(index, 1, { ...detailCategoryData, ...{selected: false, condition: [], totalVisit: 0}});
          let selectedIndex = addedCategoryData.findIndex((d) => item['activity'] == d['Standard Activity'])
          newSelectedData.splice(selectedIndex, 1)
          selection = newSelectedData.find((d) => item['activity'] == d['Standard Activity'])
        } else {
          newData.splice(index, 1, { totalVisit: 0, condition: [], ...detailCategoryData, selected: true});
          if(newSelectedData.findIndex((d) => item['activity'] == d['Standard Activity']) === -1) {
            // To avoid duplicate events added
            detailCategoryData&&newSelectedData.push(Object.assign({ totalVisit: 0, condition: [] }, detailCategoryData, { selected: true }))
            selection = newSelectedData.find((d) => item['activity'] == d['Standard Activity'])
          }
        }
        return {newData, newSelectedData, selection}
      } 

      const [openSoaDetailsModal, setShowSoaDetailsModal] = useState(false)
      const [soaModalDetails, setSoaModalDetails] = useState({})
      const [insightSelected, setInsightSelected] = useState({
                                                              action :  "",
                                                              activity : "",
                                                              activity_id : '',
                                                              category : "",
                                                              frequency : '',
                                                              key: '',
                                                            })
      const insightsHandler = () => {
        let rawInsight = [...insightEvent]
       
        rawInsight = rawInsight.filter((d) => {
        return d.activity!== insightSelected.activity
        })
        props.updateSoaActivities({soaInsightEvent: rawInsight})
        setInsightEvent(rawInsight)
        setCurrentIndex(currentIndex + 1);
      }

      const [filteredData, setFilteredData] = useState(null)
      
      const updateAddedCategory = (type, data) => {
        switch(type){
          case "Labs":
            setAddedLabs(data)
            setFilteredLabs(filterLibs(orgLabs, data, FREQUENCY_RANGE_MIN, FREQUENCY_RANGE_MAX)) 
            break;
          case "Physical Examination":
            setAddedExamination(data) 
            setFilteredExamination(filterLibs(orgExamination, data, FREQUENCY_RANGE_MIN, FREQUENCY_RANGE_MAX)) 
            break;
          case "Procedures":
            setAddedExamination(data) 
            setFilteredProcedures(filterLibs(orgProcedures, data, FREQUENCY_RANGE_MIN, FREQUENCY_RANGE_MAX)) 
            break;
          case "Questionnaires":
            setAddedExamination(data) 
            setFilteredQuestionnaires(filterLibs(orgQuestionnaires, data, FREQUENCY_RANGE_MIN, FREQUENCY_RANGE_MAX)) 
            break;
          case "Study Procedures":
            setAddedStudyProcedures(data)
            setFilteredStudyProcedures(filterLibs(orgStudyProcedures, data, FREQUENCY_RANGE_MIN, FREQUENCY_RANGE_MAX))  
            break;
          default: break;
        }
      }


      const resetAddInsights = (isSubmit) => { 
        setShowSoaDetailsModal(false);
        setSoaModalDetails({})
        isSubmit && insightsHandler()
        setFilteredData(null)
      }
      const onInsightClick = (item, type) => {
        if(type == 'add') {
          setShowSoaDetailsModal(true); 
          setInsightSelected(item) 
        } else {
          insightsHandler();
        }
        
        let resData
        switch(item.category.trim()){
          case "Labs":
            resData = handleInsightChange(orgLabs, filteredLabs, addedLabs, item) 
            if(type == 'add') {
              setShowSoaDetailsModal(true); 
              setSoaModalDetails(resData.selection)
              setFilteredData(resData.newData) 
            } else {
              setFilteredLabs(resData.newData)
              setAddedLabs(resData.newSelectedData)
              props.updateSoaActivities({
                soaAddedLabs: resData.newSelectedData, 
                soaFilteredLabs: resData.newData
              });
            }

            break; 
          case "Physical Examination":
            resData = handleInsightChange(orgExamination, filteredExamination, addedExamination, item)
            if(type == 'add') {
              setShowSoaDetailsModal(true); 
              setSoaModalDetails(resData.selection)
              setFilteredData(resData.newData)
            } else {
              setFilteredExamination(resData.newData)
              setAddedExamination(resData.newSelectedData)
              props.updateSoaActivities({
                soaAddedExamination: resData.newSelectedData, 
                soaFilteredExamination: resData.newData
              });
            }

            break;
          case "Procedures":
            resData = handleInsightChange(orgProcedures, filteredProcedures, addedProcedures, item)
            if(type == 'add') {
              setShowSoaDetailsModal(true); 
              setSoaModalDetails(resData.selection)
              setFilteredData(resData.newData)
            }else {
              setFilteredProcedures(resData.newData)
              setAddedProcedures(resData.newSelectedData) 
              props.updateSoaActivities({
                soaAddedProcedures: resData.newSelectedData, 
                soaFilteredProcedures: resData.newData
              });
            }
            break;
          case "Questionnaires":
            resData = handleInsightChange(orgQuestionnaires, filteredQuestionnaires, addedQuestionnaires, item)
            if(type == 'add') {
              setShowSoaDetailsModal(true); 
              setSoaModalDetails(resData.selection)
              setFilteredData(resData.newData)
            }else {
              setFilteredQuestionnaires(resData.newData)
              setAddedQuestionnaires(resData.newSelectedData)
              props.updateSoaActivities({
                soaAddedQuestionnaires: resData.newSelectedData, 
                soaFilteredQuestionnaires: resData.newData
              });
            }

            break;
          case "Study Procedures":
            resData = handleInsightChange(orgStudyProcedures, filteredStudyProcedures, addedStudyProcedures, item)
            if(type == 'add') {
              setShowSoaDetailsModal(true); 
              setSoaModalDetails(resData.selection)
              setFilteredData(resData.newData)
            }else {
              setFilteredStudyProcedures(resData.newData)
              setAddedStudyProcedures(resData.newSelectedData)
              props.updateSoaActivities({
                soaAddedStudyProcedures: resData.newSelectedData, 
                soaFilteredStudyProcedures: resData.newData
              });
            }

            break;
          default: break;
        }
        handleEventChange([])
      }
    
      const onDismiss = (key) => {

        if(!isSave) {
          if (props.newSoa?.currentVisitTypes === 'total_trial') {
            const totalTrialDismissedActivity = props.newSoa?.totalTrialDismissedActivity
            totalTrialDismissedActivity.push(key)

          }
          
          const currentVisitType = toSentenceCase(props.newSoa?.currentVisitTypes);
          const period = props.newSoa?.soaPeriod_data?.find(p => p.period_name === currentVisitType);
            if (period) {
              const dismissedActivities = period.soaDismissedActivity;
                dismissedActivities.push(key)
            }
        }
        // add period_type_id into dismiss event
        if (props.newSoa?.currentVisitTypes === 'total_trial') {
          key.period_type_id = null
       
        } else {
          // mapping visit type id
          const visitType = visitTypeLib.find((d) => d.visit_type === props.newSoa?.currentVisitTypes)
          key.period_type_id = visitType?.visit_type_id
          
        }     
        let rawList = [...dismissEvent]
        rawList.push(key)
        setDismissEvent(rawList)
        
        props.updateSoaActivities({ soaDismissEvent: rawList}) 
        let rawInsight = [...insightEvent]
        rawInsight = rawInsight.filter((d) => {
         return d.activity!== key.activity
        })
        setInsightEvent(rawInsight)
        setCurrentIndex(currentIndex + 1);
       
        props.updateSoaActivities({soaInsightEvent: rawInsight})
      }

      const handleCancel = () => {
        setShowConfigure(false)
      };
      const onViewImpactSummaryClick = () => {
        if(props.newSoa?.event_numbers?.weeks?.length > 0) {
          props.updateSoaActivities({soaWeeks :  props.newSoa.event_numbers?.weeks}) 
        }
        props.history.push({
          pathname: '/chart-summary',
          state: {
            trial_id: trialUUID, 
            scenarioId: scenarioId, 
            scenarioType: scenarioType,
            visits: visits,
            modalityChartData: modalityChartData,
            periodDataDetails:periodDataDetails,
            modalityOptions:modalityOptions,
            saveCostChart: saveCostChart,
            soeReadOnly: props.readOnly,
            visitTypeLib: visitTypeLib,
            soaOncologyFlag:soaOncologyFlag,
          }
        })
      };

      const viewImpactSummary = () => {
        props.updateSoaActivities(initialSoa)
        props.history.push({
          pathname: '/chart-summary',
          state: {
            trial_id: trialUUID, 
            visits: visits,
            modalityChartData: modalityChartData,
            periodDataDetails:periodDataDetails,
            soeReadOnly: props.readOnly,
          }
        })
      };

      const filterAddedInsights = (insights) => insights.filter((insight) => {
        if (insight.category === CATEGORY_LABS && insight.action === "ADD") {
          return !!!addedLabs.find(item => item['Standard Activity'] === insight.activity);
        }

        if (insight.category === CATEGORY_PHYSICAL_EXAMINATION && insight.action === "ADD") {
          return !!!addedExamination.find(item => item['Standard Activity'] === insight.activity);
        }

        if (insight.category === CATEGORY_PROCEDURES && insight.action === "ADD") {
          return !!!addedProcedures.find(item => item['Standard Activity'] === insight.activity);
        }

        if (insight.category === CATEGORY_QUESTIONNAIRES && insight.action === "ADD") {
          return !!!addedQuestionnaires.find(item => item['Standard Activity'] === insight.activity);
        }

        if (insight.category === CATEGORY_STUDY_PROCEDURES && insight.action === "ADD") {
          return !!!addedStudyProcedures.find(item => item['Standard Activity'] === insight.activity);
        }

        if (insight.category === CATEGORY_LABS && insight.action === "REMOVE") {
          return !!addedLabs.find(item => item['Standard Activity'] === insight.activity);
        }

        if (insight.category === CATEGORY_PHYSICAL_EXAMINATION && insight.action === "REMOVE") {
          return !!addedExamination.find(item => item['Standard Activity'] === insight.activity);
        }

        if (insight.category === CATEGORY_PROCEDURES && insight.action === "REMOVE") {
          return !!addedProcedures.find(item => item['Standard Activity'] === insight.activity);
        }

        if (insight.category === CATEGORY_QUESTIONNAIRES && insight.action === "REMOVE") {
          return !!addedQuestionnaires.find(item => item['Standard Activity'] === insight.activity);
        }

        if (insight.category === CATEGORY_STUDY_PROCEDURES && insight.action === "REMOVE") {
          return !!addedStudyProcedures.find(item => item['Standard Activity'] === insight.activity);
        }
      });

      const [soaActiveKey, setSoaActiveKey] = useState(() => {
      const storedData = JSON.parse(localStorage.getItem('collapseCharts'));
      return storedData ? storedData.soaCollapse : ['1'];
    })

      function soaCallback(key) {
         const storedData = JSON.parse(localStorage.getItem('collapseCharts'));
        if (storedData) {
         storedData.soaCollapse = key;
         const updatedDataString = JSON.stringify(storedData);
         localStorage.setItem('collapseCharts', updatedDataString);
        } else{
          localStorage.setItem('collapseCharts', JSON.stringify({"endpointCollapse" : ['1'],
                                                    "inclusionCollapse" : ['1'],
                                                    "exclusionCollapse" : ['1'],
                                                    "soaCollapse" : key
                                                    }));
        }
        setSoaActiveKey(key)
      }

  useEffect(() => {
    setSoaActiveKey(soaActiveKey)
  }, [soaActiveKey]);
    const [chartData, setChartData] = useState(() => {
    const localData = localStorage.getItem('chartData');
    return localData ? JSON.parse(localData) : [];
  });
    const [customChartData, setCustomchartData]= useState(() => {
      const localData = localStorage.getItem('chartData');
      return localData ? JSON.parse(localData) : [];
    });
      
      // const [ selectedChartID, setSelectedChartID ] = useState([]);
      const [ DCTonPB, setDCTonPB ] = useState({ pb: { total_dct_pb: 0,total_pb: 0 }, pb_insights_data: []})
      const [ DCTonPBInsightsData, setDCTonPBInsightsData ] = useState([])
      const [ PBbyCategoryInsightsData, setPBbyCategoryInsightsData ] = useState([])
      const [ SBbyCategoryInsightsData, setSBbyCategoryInsightsData ] = useState([])
      const [ costPerPatientByCategoryData, setCostPerPatientbyCategoryData ] = useState([])
      const [ countOfSOAByCategoryData, setCountOfSOAByCategoryData ] = useState([])
      const [ activityUtilization, setActivityUtilization ] = useState([])
      const [ timeSpentInTrial, setTimeSpentInTrial] = useState({
        scenario_time:0,
        historic_time:0
      })
      const [ timeSpentByRole, setTimeSpentByRole] = useState([])
      const [ PBVisit, setPBVisit ] = useState( {
        total_dct_pb_per_visit: [], 
        total_dct_pb: 0, 
        sht_total_pb_median: 0, 
        sht_total_pb_median_first_visit: 0, 
        sht_total_pb_median_visits: 0,
         dct_pb_state: ""})
      const [ TimeSpentByVisitData, setTimeSpentByVisitData ] = useState( { 
      tb_by_visit: [], 
      total_tb: 0, 
      sht_total_tb_median: 0, 
      sht_total_tb_median_first_visit: 0, 
      sht_total_tb_median_subseq_visits: 0,
      tb_state: ""})
      const [topActivitiesbyCost, setTopActivitiesbyCost] = useState([])
      const [ costPerVisit, setCostPerVisit ] = useState( { 
        cost_per_state: [], 
        total_cost: 0, 
        sht_total_cost_median: 0, 
        sht_total_cost_median_first_visit: 0, 
        sht_total_cost_median_subseq_visits: 0, 
        cost_state: ""})
      const [ dimensionBurden, setDimensionBurden ] = useState([]);
      // const [newModalityChartData, setNewModalityChartData] = useState(modalityChartData)
      const [soaActivitiesCount, setsoaActivitiesCount] = useState({
          total_count_per_visit:[],
          total_count: 0,
          sht_total_count_median:0,
          median_count_soa_subsequent_visits:0,
          median_count_soa_first_visit:0,
          count_state:""
        })
      
      const [SOAByAtGlanceChart, setSOAByAtGlance] = useState({
        pb_insights_data: {
          number_of_activities_soa: 0,
          number_of_activities_median: 0,
          number_of_visits_soa: 0,
          number_of_visits_median: 0,
          patient_burden_soa: 0,
          patient_burden_median: 0,
          cost_soa: 0,
          cost_median: 0,
        },
      });
      const [ SBVisit, setSBVisit ] = useState({ 
      total_dct_sb_per_visit: [], 
      total_dct_sb: 0, 
      sht_total_sb_median: 0, 
      sht_total_sb_median_first_visit: 0, 
      sht_total_sb_median_visits: 0,
      dct_sb_state: ""
    })
      const [ DCTonSB, setDCTonSB ] = useState({ sb: { total_dct_sb: 0,total_sb: 0 }, sb_insights_data: []})
      const [ DCTonSBInsightsData, setDCTonSBInsightsData ] = useState([])
      const [ sDDimensionBurden, setSDDimensionBurden ] = useState([]);
      const [ visitLevelAnalysisData, setVisitLevelAnalysisData ] = useState<VisitLevelAnalysisDataType[]>([]);
      const [ SBbyCategoryData, setSBbyCategoryData ] = useState([])
      const getModalityOptionData = (modalitySeries,currentVisitIndex) => {
       return modalitySeries?.map((item) => ({
          ...item, 
          data: item.data.map((val, index) => {
            return {
              value: val,
              itemStyle: {color: !soaOncologyFlag?modality_options_dict[item.name].color:(currentVisitIndex.includes(index+1)? modality_options_dict[item.name].color:'#DEDEDE')}
            }
          }),
          name: item.name=== 'eConsent'? item.name : toSentenceCase(item.name),
          // color: modality_options_dict[item.name].color, 
          type:"bar",
          stack:"total",
          emphasis:{"focus":"series"}}))
      }

      // const [modalityVisits, setModalityVisits] = useState([])
      const fetchOneChart = async (chartID) => {
        const trial_id = props.trial_uuid
        switch (chartID) { 
           // SOA At Glance
           case 1:
            const resGlance = await getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'),"SoAatGlance", false, true,props.newSoa?.currentVisitTypes) 
            if (resGlance  && Object.keys(resGlance).length !== 0 && resGlance.message !== "Error processing request" && resGlance.pb_insights_data !== null) {
              const response = resGlance
              setSOAByAtGlance(response)  
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            } 
            break;
          // Activities By Modality
          case 2:
            const resModality = await getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'),"Modality", false, true,props.newSoa?.currentVisitTypes) 
            if (resModality  && Object.keys(resModality).length !== 0 && resModality.message !== "Error processing request" && resModality.pb_insights_data !== null) {
              const response = resModality 
              const modalitySeries = response['pb_insights_data']['modalities_by_visits'] 
              setModalityChartOrgData(modalitySeries) 
              // let modality_options = getModalityOptionData(modalitySeries, currentVisitIndex)
              // setModalityChartData(modality_options)  
              // setModalityVisits(response['pb_insights_data']['visits']  )
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            } 
            break;
          // Patient Burden by Activity Category
          case 3:
            const res = await getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'),"Category", true, true,props.newSoa?.currentVisitTypes)
            if (res  && Object.keys(res).length !== 0) {
              const response = res
              setPBbyCategoryInsightsData(response['pb_insights_data'])
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            }else{
              message.error('Failed to fetch chart data')
            }
            break;
           //  Patient burden by Dimension
          case 4:
            const respDimension = await getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "dimensionWithHist", false, true,props.newSoa?.currentVisitTypes)
            if (respDimension  && Object.keys(respDimension).length !== 0) {
              const response = respDimension;
              setDimensionBurden(response['pb_insights_data'])
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            }else{
              message.error('Failed to fetch chart data')
            }
            break;
          //  DCT Impact on Patient Burden
          case 5:
            const resp = await getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'),"Dimension", true, false,props.newSoa?.currentVisitTypes)
            if (resp  && Object.keys(resp).length !== 0) {
              const response = resp
              const insightData = response['pb_insights_data']?.map((item, index)=>{
                // const diff = item.patient_burden - item.dct_patient_burden
                // item.patient_burden = diff
                return item
              })
              setDCTonPB(response)
              setDCTonPBInsightsData(insightData) 
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            }else{
              message.error('Failed to fetch chart data')
            }
            break;
          //  Count of SoA Activities by Activity Category
          case 6:
            const resd = await getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'),"CountOfSOAByCategory", false, true,props.newSoa?.currentVisitTypes)
            if (resd  && Object.keys(resd).length !== 0) {
              const response = resd
              setCountOfSOAByCategoryData(response['soa_by_category'])
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            }else{
              message.error('Failed to fetch chart data')
            }
            break;
          //  Patient Burden by Visit
          case 7:
            const resdvisit = await getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'),"Visit", false, true,props.newSoa?.currentVisitTypes)
            if (resdvisit  && Object.keys(resdvisit).length !== 0) {
              const response = resdvisit;
              setPBVisit(response['pb_insights_data'])  
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            }else{
              message.error('Failed to fetch chart data')
            }
            break;
          // Cost per Patient by Visit
          case 8:
            const resCostVisit= await getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'),"CostPerPatientByVisit", false, true,props.newSoa?.currentVisitTypes)
            if (resCostVisit  && Object.keys(resCostVisit).length !== 0) {
              const response = resCostVisit;
              setCostPerVisit(response['pb_insights_data']) 
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            }else{
              message.error('Failed to fetch chart data')
            }
            break;
          //  Cost per Patient by Activity Category
          case 9:
            const resCostbySoa = await getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "CostPerPatientByCategory", false, true,props.newSoa?.currentVisitTypes)
            if (resCostbySoa  && Object.keys(resCostbySoa).length !== 0) {
              const response = resCostbySoa;      
                setCostPerPatientbyCategoryData(response['pb_insights_data'])
                setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            }else{
              message.error('Failed to fetch chart data')
            }
            break;
            // Top Activities by Cost
          case 10:
            const respTopActivity = await getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "topActivity", false, false,props.newSoa?.currentVisitTypes)
            if (respTopActivity  && Object.keys(respTopActivity).length !== 0) {
              const response = respTopActivity;      
              if (response['pb_insights_data'] === null) {
                setTopActivitiesbyCost([])
              } else {
                setTopActivitiesbyCost(response['pb_insights_data'])
                setSearchedRawDataTopActivity(response['pb_insights_data'])
              }
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            }else{
              message.error('Failed to fetch chart data')
            }
            break;
           // Count of SoA Activities by Visit
          case 11:
            const resSoaCount= await getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "CountOfSoaActivitiesByVisit", false, true,props.newSoa?.currentVisitTypes)
            if (resSoaCount  && Object.keys(resSoaCount).length !== 0) {
              const response = resSoaCount;
              setsoaActivitiesCount(response['pb_insights_data'])
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            }else{
              message.error('Failed to fetch chart data')
            }
            break;
          
          case 12:
            const resActivity= await getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "Activity_Utilization", false, true,props.newSoa?.currentVisitTypes)
            if (resActivity  && Object.keys(resActivity).length !== 0) {
              const response = resActivity; 
              setActivityUtilization(response['pb_insights_data']?.filter(item => item.activity_id !== null))
              setSearchedRawDataActivityUT(response['pb_insights_data']?.filter(item => item.activity_id !== null))
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            }else{
              message.error('Failed to fetch chart data')
            }
            break;
          // DCT Impact on Site Burden
          case 13:
            const resSiteBurden = await getTrialSBInsights(trial_id, localStorage.getItem('ts_id'),"SiteBurdenDimension", true, props.newSoa?.currentVisitTypes)
            if (resSiteBurden  && Object.keys(resSiteBurden).length !== 0) {
              const response = resSiteBurden
              const insightData = response['sb_insights_data']?.map((item, index)=>{
                return item
              })
              setDCTonSB(response)
              setDCTonSBInsightsData(insightData) 
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            }else{
              message.error('Failed to fetch chart data')
            }
            break;
          // Site burden by dimension
          case 14:
            const respSDDimension = await getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "OHSiteBurdenByDimension", false, props.newSoa?.currentVisitTypes)
            if (respSDDimension  && Object.keys(respSDDimension).length !== 0) {
              const response = respSDDimension;
              setSDDimensionBurden(response['sb_insights_data'])
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            }else{
              message.error('Failed to fetch chart data')
            }
            break;
          // Time Spent in Trial
          case 15:
            const resSpentTime= await getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "TimeSpentInTrial", false, props.newSoa?.currentVisitTypes)
            if (resSpentTime  && Object.keys(resSpentTime).length !== 0) {
              const response = resSpentTime;
              setTimeSpentInTrial(response['sb_insights_data'][0]?.Patient)
              setTimeSpentByRole(response['sb_insights_data'][1]?.time_burden_by_activity)
              setSoaLoadedCharts(prevArray => {
                if (!prevArray.includes(chartID)) {
                  return [...prevArray, chartID];
                }
                return prevArray;
              });
            }else{
              message.error('Failed to fetch chart data')
            }
          break;
           // Time spent by activity category
           case 16:
            const resTimeByAct = await getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "TimeBurdenByCategory", false, props.newSoa?.currentVisitTypes)
            if (resTimeByAct  && Object.keys(resTimeByAct).length !== 0) {
              const response = resTimeByAct
              setSBbyCategoryInsightsData(response['sb_insights_data'])
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            }else{
              message.error('Failed to fetch chart data')
            }
            break;
          // Site burden by visit
          case 17:
            const resSiteBurdenVisit= await getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "SiteBurdenVisit", false, props.newSoa?.currentVisitTypes)
            if (resSiteBurdenVisit  && Object.keys(resSiteBurdenVisit).length !== 0) {
              const response = resSiteBurdenVisit;
              setSBVisit(response['sb_insights_data'])
              setSoaLoadedCharts(prevArray => {
                if (!prevArray.includes(chartID)) {
                  return [...prevArray, chartID];
                }
                return prevArray;
              });
            }else{
              message.error('Failed to fetch chart data')
            }
          break;
          // Time spent by visit
          case 18:
            const resTSByVisit = await getTrialSBInsights(trial_id, localStorage.getItem('ts_id'),"TimeSpentByVisit", false,props.newSoa?.currentVisitTypes)
            if (resTSByVisit  && Object.keys(resTSByVisit).length !== 0) {
              const response = resTSByVisit;
              const sbInsightsData = JSON.parse(JSON.stringify(response['sb_insights_data']))
              sbInsightsData?.tb_by_visit?.forEach(visit => {
                visit.time_burden = convertToHours(visit.time_burden);
              });
              sbInsightsData.sht_total_tb_median_first_visit = convertToHours(sbInsightsData.sht_total_tb_median_first_visit);
              sbInsightsData.sht_total_tb_median_subseq_visits = convertToHours(sbInsightsData.sht_total_tb_median_subseq_visits);              
              setTimeSpentByVisitData(sbInsightsData)  
              timeSpentRef.current = sbInsightsData;
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });     
            }else{
              message.error('Failed to fetch chart data')
            }
          break;
           // Visit level Analysis
           case 19:
            const visitLevelAnalysisData =  await getTrialSoaInsights(trial_id, localStorage.getItem('ts_id'), "VisitLevelAnalysis", false, false, props.newSoa?.currentVisitTypes);
            if (visitLevelAnalysisData  && Object.keys(visitLevelAnalysisData).length !== 0) {
              const response = visitLevelAnalysisData;
              const pbInsightsData = JSON.parse(JSON.stringify(response['pb_insights_data']))
              setVisitLevelAnalysisData(pbInsightsData?.combined_metrics_list)
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });   
            }else{
              message.error('Failed to fetch chart data')
            }
          break;

           // Site Burden by Activity Group
           case 20:
            const sbCategoryData =  await getTrialSBInsights(trial_id, localStorage.getItem('ts_id'), "SiteBurdenByCategory", true, props.newSoa?.currentVisitTypes);
            if (sbCategoryData  && Object.keys(sbCategoryData).length !== 0) {
              const response = sbCategoryData;
              const sbInsightsData = JSON.parse(JSON.stringify(response['sb_insights_data']))
              setSBbyCategoryData(sbInsightsData)
              setSoaLoadedCharts(prevArray => {  
                if (!prevArray.includes(chartID)) {  
                  return [...prevArray, chartID];  
                }  
                return prevArray;
              });   
            }else{
              message.error('Failed to fetch chart data')
            }
          break;
          default:
            break;
        }
      }

      // const initialTabs = ['Overview', 'Activity Utilization', 'Activity Cost', 'Patient Burden'];
      const initialTabs = ['Overview', 'Activity Cost', 'Patient Burden','Site Burden','Patient Time'];
      // const [activeTab, setActiveTab] = useState<string>('Overview');

      const [activeTab, setActiveTab] = useState(() => {
        const selectedTab = localStorage.getItem('soaPresetActiveTabKey');
        return selectedTab && selectedTab !== 'null' ? selectedTab : 'Overview'
      })

      useEffect(() => {
        localStorage.setItem('soaPresetActiveTabKey', activeTab);
        handleTabClick(activeTab);
      }, [activeTab])
      
      const [tabs, setTabs] = useState<string[]>(initialTabs);
      const ts_id = localStorage.getItem('ts_id');
      useEffect(() => {
        const fetchCustomData = async () => {
        try {
          const response = await getChartsData(props.trial_uuid, ts_id + '');
          const isCustomTabVisible = response.some(chart => chart.selected);
  
          if (isCustomTabVisible && !tabs.includes('Custom')) {
            setTabs(prevTabs => [...prevTabs, 'Custom']);
          }
        } catch (error) {
          console.error('Error fetching chart data:', error);
        }
      };
  
      fetchCustomData();
    }, [props.trial_uuid, ts_id, tabs]);

      let selectedCharts;
      if (customChartData) {
        selectedCharts = customChartData.filter(chart => chart.selected).map(chart => chart.name);
      } 
     

      const tabCharts = {
        'Overview': ['SoA at a Glance', 'Activities by Modality'],
        'Activity Utilization': ['Activity Utilization in Historical Trials','Count of SoA Activities by Activity Category'],
        'Activity Cost':['Top Activities by Cost','Cost per Patient by Activity Category'],
        'Patient Burden': ['Patient burden by Dimension','Patient Burden by Activity Category'],
        'Site Burden': ['OH Site burden by dimension','Site Burden by Activity Category'],
        'Patient Time': ['Time Spent in Trial', 'Time spent by activity category'],
        'Custom': selectedCharts
      };
      const clearLoadedCharts = () => {
        setSoaLoadedCharts([]);
      }
      const fetchChartData = async (chartData) => { 
        let chartID = [];
        clearLoadedCharts();
        chartData.forEach((chart) => {
          if (chart.selected) {
            chartID.push(chart.id);
            fetchOneChart(chart.id)
            setSelectedChartID(chartID)
          }
        });
      }

      const whetherDisplay = (chartName) => {
        const chart = chartData.find((chart) => chart.name === chartName);  
        if (chart) {
          return chart.selected
        }
      }

       function triggerChartFetch() {
        if (JSON.parse(localStorage.getItem('chartData'))) {
          setChartData(JSON.parse(localStorage.getItem('chartData')));
           fetchChartData(JSON.parse(localStorage.getItem('chartData')));
        } else {
          const getChartSummaryData = async (trial_uuid, ts_id) => {
            const response = await getChartsData(trial_uuid, ts_id + '');
            if(response?.length > 0) {
              localStorage.setItem('chartData', JSON.stringify(response));
              setChartData(response);
               fetchChartData(response);
            } else {
              localStorage.setItem('chartData', JSON.stringify(defaultChartData));
              setChartData(JSON.parse(JSON.stringify(defaultChartData)));
               fetchChartData(defaultChartData);
            }
          }
          getChartSummaryData(props.trial_uuid, localStorage.getItem('ts_id'));
        }
      }
      useEffect(() => {
        // setActiveTab(activeTab);
        // handleTabClick(activeTab);
        triggerChartFetch();
    }, [props.newSoa?.currentVisitTypes]);
      
     
      const handleTabClick = (tabName) => {
        let newChartData = JSON.parse(JSON.stringify(chartData))      
        newChartData.forEach((chart) => {
          chart.selected = false;
        });

          if (tabCharts[tabName]) {
            tabCharts[tabName].forEach(chartName => {
              const chartIndex = newChartData.findIndex(chart => chart.name === chartName);
              if (chartIndex !== -1) {
                newChartData[chartIndex].selected = true;
              }
            });
          
        }
        setChartData(newChartData);
        localStorage.setItem('chartData', JSON.stringify(newChartData))
        localStorage.setItem('soaPresetActiveTabKey', tabName)
        triggerChartFetch();
        setActiveTab(tabName);
      
      };
      
      
      

      const {
        PBbyActivityCategoryOption,
        TimeSpentByVisitOption,
        DCTonPBOption,
        costPatientByCategoryOption,
        countSOAbyCategoryOption,
        visitChartOption,
        costVisitChartOption,
        soaActivitiesChartOption,
        DCTonSBOption,
        TimeByCategoryOption,
        sitevisitChartOption,
        SBbyActivityCategoryOption
      } = getChartOptions(
        PBVisit,
        TimeSpentByVisitData,
        costPerVisit,
        PBbyCategoryInsightsData,
        DCTonPBInsightsData,
        costPerPatientByCategoryData,
        countOfSOAByCategoryData,
        soaActivitiesCount,
        '25%',
        props.newSoa?.currentVisitTypes,
        DCTonSBInsightsData,
        SBbyCategoryInsightsData,
        SBVisit,
        SBbyCategoryData
        )

      const columns = [
        {
          title: "PB dimension",
          dataIndex: "dimension_name",
          ellipsis: true, 
          width: 220,
          sorter: (a, b) => (a.dimension_name < b.dimension_name ? -1 : 1),
          render: (text, record, index) => {
            const relatedActivities = record.related_activities || [];
            return (

            <Tooltip
              title={
                <div className="tooltip-content">
                <strong className="tooltip-title">Related Activities</strong>
                {relatedActivities.length > 0 ? (
                  <ul className="tooltip-list custom-tooltip-content">
                    {relatedActivities.map((activity, index) => (
                      <li key={index} className="tooltip-list-item">
                        <span className='hyphen'>-</span>
                        <span className='activity'>{activity}</span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div className='no_data'>No related activity in this scenario</div>
                )}
                
                </div>
              }
              visible={patientBurdenTooltipVisible === index}
              onVisibleChange={(visible) => setPatientBurdenTooltipVisible(visible ? index : null)}
              trigger="click"
              placement='right'
              overlayInnerStyle={{ backgroundColor: '#f5f5f5', color: 'black', border: '1px solid #d9d9d9', borderRadius: '20%' }}
            >
            <span style={{cursor: 'pointer', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block', maxWidth: '100%'}}
            onClick={() => setPatientBurdenTooltipVisible(patientBurdenTooltipVisible === index ? null : index)}>
              {text}
            </span>
           </Tooltip>
            );
          }
        },
        {
          title: "Scenario value",
          dataIndex: pbPerVisit? "scenario_value_by_visit":"scenario_value",
          ellipsis: true,
          render: item => <span>{formatWithCommas(Math.round(item))}</span>,
          sorter: (a, b) => pbPerVisit ? a.scenario_value_by_visit - b.scenario_value_by_visit : a.scenario_value - b.scenario_value,

        },
        {
          title: "Historical median",
          dataIndex: pbPerVisit ? "historical_median_by_visit" : "historical_median",
          ellipsis: true, 
          render: item => <span>{formatWithCommas(Math.round(item))}</span>,
          sorter: (a, b) => pbPerVisit ? a.historical_median_by_visit - b.historical_median_by_visit : a.historical_median - b.historical_median,
        },
        {
          title: "Difference",
          dataIndex: pbPerVisit ? "difference_by_visit" : "difference",
          ellipsis: true, 
          render: item => <span style={{color: parseInt(item) >= 0 ?  'red' : 'green'}}>{formatWithCommas(Math.round(item))}</span>,
          sorter: (a, b) => pbPerVisit ? a.difference_by_visit - b.difference_by_visit : a.difference - b.difference,
        } 
      ];
    
      const sDDimensionColumns = [
        {
          title: "Role",
          dataIndex: "sb_dimension_name",
          ellipsis: true, 
          width: 220,
          sorter: (a, b) => (a.sb_dimension_name < b.sb_dimension_name ? -1 : 1),
          render: (text, record, index) => {
            const relatedActivities = record.related_activities || [];
            return (
             
            <Tooltip
              title={
                <div className="tooltip-content">
                <strong className="tooltip-title">Related Activities</strong>
                {relatedActivities.length > 0 ? (
                  <ul className="tooltip-list custom-tooltip-content">
                    {relatedActivities.map((activity, index) => (
                      <li key={index} className="tooltip-list-item">
                        <span className='hyphen'>-</span>
                        <span className='activity'>{activity}</span>
                      </li>
                    ))}
                  </ul>
                ) : (
                  <div className='no_data'>No related activity in this scenario</div>
                )}
                </div>
              }
              visible={siteBurdenTooltipVisible === index}
              onVisibleChange={(visible) => setSiteBurdenTooltipVisible(visible ? index : null)}
              trigger="click"
              placement='right'
              overlayInnerStyle={{ backgroundColor: '#f5f5f5', color: 'black', border: '1px solid #d9d9d9', borderRadius: '20%' }}
            >
              <span style={{cursor: 'pointer', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', display: 'inline-block', maxWidth: '100%'}}
              onClick={() => setSiteBurdenTooltipVisible(siteBurdenTooltipVisible === index ? null : index)}>
                {text}
              </span>
            </Tooltip>
            );
          }
        },
        {
          title: "Scenario value",
          dataIndex: sbPerVisit? "scenario_value_by_visit":"scenario_value",
          ellipsis: true,
          render: item => <span>{Math.round(item)}</span>,
          sorter: (a, b) => sbPerVisit ? a.scenario_value_by_visit - b.scenario_value_by_visit : a.scenario_value - b.scenario_value,
        },
        {
          title: "Historical median",
          dataIndex: sbPerVisit ? "historical_median_by_visit" : "historical_median",
          ellipsis: true, 
          render: item => <span>{Math.round(item)}</span>,
          sorter: (a, b) => sbPerVisit ? a.historical_median_by_visit - b.historical_median_by_visit : a.historical_median - b.historical_median,

        },
        {
          title: "Difference",
          dataIndex: sbPerVisit ? "difference_by_visit" : "difference",
          ellipsis: true, 
          render: item => <span style={{color: parseInt(item) >= 0 ?  'red' : 'green'}}>{Math.round(item)}</span>,
          sorter: (a, b) => pbPerVisit ? a.difference_by_visit - b.difference_by_visit : a.difference - b.difference,

        } 
      ];

      const [searchTextTopActivity, setSearchTextTopActivity] = useState('');
      const [searchedRawDataTopActivity, setSearchedRawDataTopActivity] = useState([]);
      const searchInputTopActivity = useRef(null);
    
      const handleSearchChangeTopActivity = (event) => {
        const value = event.target.value; 
        setSearchTextTopActivity(value)
        const filtered = [...searchedRawDataTopActivity].filter((record) => {
          const recordValue = record['activity'] ? record['activity'].toString().toLowerCase() : "";
          return recordValue.includes(value);
        })
        setTopActivitiesbyCost(filtered)  
      };

      const columnsTopActivity = [
        {
          title: () => (  
            <div>  
              {toSentenceCase("ACTIVITY")}
              <Input 
              placeholder="Search" 
              style={{ 
                width: '100%',
                height: '30px',
                display: 'flex',
                backgroundColor: '#F8F8F8',
    
              }} 
              onClick={(e) => e.stopPropagation()}
              value={searchTextTopActivity}
              ref={searchInputTopActivity}
              onChange={handleSearchChangeTopActivity}
              prefix={<SearchOutlined style={{
                color: "#666",
                fontSize: 14,
              }}/>}
              />  
            </div>  
          ), 
          dataIndex: "activity",
          ellipsis: true, 
          width: 220,
          sorter: (a, b) => (a.activity < b.activity ? -1 : 1),
        },
        {
          title: toSentenceCase("COST PER VISIT"),
          dataIndex: "cost_per_patient",
          ellipsis: true,
          defaultSortOrder: 'descend' as SortOrder,
          render: item => <span>${Math.round(item)}</span>,
          sorter: (a, b) => a.cost_per_patient - b.cost_per_patient, 
        },
        {
          title: toSentenceCase("TOTAL VISITS"),
          dataIndex: "total_visits",
          ellipsis: true, 
          render: item => <span>{Math.round(item)}</span>,
          sorter: (a, b) => a.total_visits - b.total_visits, 
        },
        {
          title: toSentenceCase("TOTAL COST"),
          dataIndex: "total_cost",
          ellipsis: true, 
          render: item => <span style={{fontWeight: 600}}>${Math.round(item)}</span>,
          sorter: (a, b) => a.total_cost - b.total_cost, 
        } 
      ];

      const [searchTextActivityUT, setSearchTextActivityUT] = useState('');
      const [searchedRawDataActivityUT, setSearchedRawDataActivityUT] = useState([]);
      const searchInputActivityUT = useRef(null);

      const handleSearchChangeActivityUT = (event) => {
        const value = event.target.value; 
        setSearchTextActivityUT(value)
        const filtered = [...searchedRawDataActivityUT].filter((record) => {
          const recordValue = record['std_activity'] ? record['std_activity'].toString().toLowerCase() : "";
          return recordValue.includes(value);
        })
        setActivityUtilization(filtered)  
      };

      const activity_utilization_columns = [
        {
          title: () => (  
            <div>  
              Activity
              <Input 
              placeholder="Search" 
              style={{ 
                width: '100%',
                height: '30px',
                display: 'flex',
                backgroundColor: '#F8F8F8',
    
              }} 
              onClick={(e) => e.stopPropagation()}
              value={searchTextActivityUT}
              ref={searchInputActivityUT}
              onChange={handleSearchChangeActivityUT}
              prefix={<SearchOutlined style={{
                color: "#666",
                fontSize: 14,
              }}/>}
              />  
            </div>  
          ), 
          dataIndex: "std_activity",
          ellipsis: true, 
          width: 220,
          sorter: (a, b) => (a.std_activity < b.std_activity ? -1 : 1),
        },
        {
          title: (  
            <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>  
             Historical activity frequency
            </div>  
          ), 
          dataIndex: "historic_activity_frequency",
          ellipsis: true, 
          render: item => <span>{item === null ? '-' : Math.round(item * 100) / 100}</span>,
          // render: item => <span>{item?.toFixed(2)}</span>,
          sorter: (a, b) => a.historic_activity_frequency - b.historic_activity_frequency, 
        },
        {
          title: (  
            <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>  
             Historical visit frequency 
            </div>  
          ),  
          dataIndex: "historic_visit_frequency",
          ellipsis: true, 
          render: item => <span>{item===null&&soaOncologyFlag? 'NA' : Math.round(item * 100) / 100}</span>,
          sorter: (a, b) => a.historic_visit_frequency - b.historic_visit_frequency, 
        },
        {
          title: (  
            <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>  
            Scenario Visit Frequency
            </div>  
          ), 
          dataIndex: "scenario_visit_frequency",
          ellipsis: true, 
          render: item => <span>{item===null&&soaOncologyFlag? 'NA' : Math.round(item * 100) / 100}</span>,
          sorter: (a, b) => a.scenario_visit_frequency - b.scenario_visit_frequency, 
        },
        {
          title: "Difference",
          dataIndex: "difference",
          ellipsis: true,
          // render: item => <span style={{color: parseInt(item) >= 0 ?  'red' : 'green'}}>{Math.round(item)}</span>,
          render: (item, record) => <span style={{color: (parseInt(record?.historic_visit_frequency) - parseInt(record?.scenario_visit_frequency)) >= 0 ?  'red' : 'green'}}>{record?.historic_visit_frequency===null&&record?.scenario_visit_frequency===null&&soaOncologyFlag? 'NA': Math.round( record?.historic_visit_frequency - record?.scenario_visit_frequency)}</span>, 
          sorter: (a, b) => (a.historic_visit_frequency - a.scenario_visit_frequency) - (b.historic_visit_frequency - b.scenario_visit_frequency)  
        },
      ];

      const time_spent_columns = [
        {
          title: "Activity",
          dataIndex: "std_activity",
          ellipsis: true,
          width: 220,
          sorter: (a, b) => (a.std_activity < b.std_activity ? -1 : 1),
        },
        {
          title: (
            <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>
             Scenario value
            </div>
          ),
          dataIndex: "scenario_time",
          ellipsis: true,
          render: item => <span>{item===null? 'NA' : convertToHours(item)}</span>,
          sorter: (a, b) => a.scenario_time - b.scenario_time,
        },
        {
          title: (
            <div style={{ whiteSpace: 'normal', lineHeight: '1.2' }}>
            Historical median
            </div>
          ),
          dataIndex: "historic_time",
          ellipsis: true,
          render: item => <span>{item===null? 'NA' : convertToHours(item)}</span>,
          sorter: (a, b) => a.historic_time - b.historic_time,
        },
        {
          title: "Difference",
          dataIndex: "difference",
          ellipsis: true,
          render: (item, record) => <span style={{color: (parseInt(record?.scenario_time) - parseInt(record?.historic_time)) >= 0 ?  'red' : 'green'}}>
            {record?.scenario_time===null&&record?.historic_time===null? 'NA':
          convertToHours(record?.scenario_time - record?.historic_time)}
          </span>,
          sorter: (a, b) => (a.scenario_time - a.historic_time) - (b.scenario_time - b.historic_time)
        },
      ];

      const handlePeriodType = async(e) => {
        if(!soaOncologyFlag) return
        setCurrentVisitTypes(e)
        props.updateSoaActivities({
          currentVisitTypes: e  ,
        }) 
      }
      const topActivitiesmessage = 'The "Top activities by cost" chart reflects the cost across the entire trial in oncology';

      const getFilterMessage = (v) => {
        switch(v){
          case "total_trial":
            return <span>Metrics for 'Total trial' are estimated using the estimated treatment duration supplied during trial creation.</span>
          case "Screening Visits":
            return <span>Metrics are for Screening visits only.</span>
          case "Fixed Cycle":
            return <span>Metrics apply to only visits within 'Fixed Cycles'.</span>
          case "Repeating Cycle":
            return <span>Metrics apply to only visits within 'Repeating Cycles'.</span>
          case "Follow-up Visits":
            return <span>Metrics are for End of Treatment visits only.</span>
        }
      }

      const getPeriodTypeText = () => {
        switch(props.newSoa?.currentVisitTypes){
          case "total_trial":
            return <span></span>
          case "Screening Visits":
            return <span>in <b>screening</b></span>
          case "Fixed Cycle":
            return <span>in <b>a fixed cycle period</b></span>
          case "Repeating Cycle":
            return <span>in <b> a repeating cycle period</b></span>
          case "Follow-up Visits":
            return <span>in <b>follow-up</b></span>
        }
      }

      const getPeriodTypeSecondText = () => {
        switch(props.newSoa?.currentVisitTypes){
          case "total_trial":
            return <span></span>
          case "Screening Visits":
            return <span><b>screening</b> in </span>
          case "Fixed Cycle":
            return <span><b>the fixed cycle period</b> in </span>
          case "Repeating Cycle":
            return <span><b>the repeating cycle period</b> in </span>
          case "Follow-up Visits":
            return <span><b>follow-up</b> in </span>
        }
      }

    const CustomHeaderWrapper = ({ children }) => {
      return <thead>
        {children}
        {/* {parentRow} */}
        </thead>;
    };

    const [siteTimeTab, setSiteTimeTab] = useState('total_trial');

    const onSiteTimeTabChange = (e) => {
      setSiteTimeTab(e.target.value)
    };

    const [pbSelectedTab, setPbSelectedTab] = useState('pb_totalTrial');
    const [sbSelectedTab, setSbSelectedTab] = useState('sb_totalTrial');
  
    useEffect(() => {
      setPbSelectedTab('pb_totalTrial');
      setSbSelectedTab('sb_totalTrial');
      setpbPerVisit(false);
      setsbPerVisit(false);
    }, [currentVisitTypes]);
  
    const handleTabChange = (selectedValue, section) => {
      if (section === 'pb') {
        setPbSelectedTab(selectedValue);
        setpbPerVisit(selectedValue === 'pb_perVisit');
      } else if (section === 'sb') {
        setSbSelectedTab(selectedValue);
        setsbPerVisit(selectedValue === 'sb_perVisit');
      }
    };

  const timeSpentRef = useRef(null);
  const {
    tooltipVisible,
    setTooltipVisible,
    tooltipContent,
    tooltipPosition,
    tooltipRef,
    handleChartClick, 
  } = useChartTooltip();
    
  const onChartReady = (chart) => {
    chart.on('click', (params) => {
      if (params.componentType === 'markLine') {
        return; 
      }else {
        handleChartClick(params, timeSpentRef.current); 
      }
    });
  };

    return (
    <>
      <div className="soa-activities-container">
        <div className="scenarios-actions-container"> 
            <Col span={soeLibrarayPanelStatus ? 18 : 23} style={{paddingRight: '2%'}}>
              <Row>
                <Col span={20}>
                <div className="scenarios-heading-left"> 
              {/* <span> Scenario impact summary </span> */}
            
                </div>
                </Col>
            </Row> 
            <Collapse activeKey={soaActiveKey} onChange={soaCallback} expandIconPosition="right" >
              <Panel 
              header={
              <div>
                <span style={{fontSize:'26px', marginRight: 40}}>Scenario impact summary</span>
                <div style={{display: 'inline-block'}} onClick={e => e.stopPropagation()}>
                  <label htmlFor="" style={{color:'#000000',marginRight: 15}}>By period type:</label>
                  <Select
                      value={currentVisitTypes.toString()}
                      style={{ width: '250px' }}
                      onChange={handlePeriodType}
                      defaultValue="total_trial"
                  >
                    <Option value="total_trial">Total trial</Option>
                    {soaOncologyFlag && visitTypeLib.map((item) => (
                      <Option 
                      key={item?.visit_type} 
                      value={item?.visit_type}
                      >
                        {toSentenceCase(item?.visit_type)}
                      </Option>
                    ))}
                  </Select>
                  <Tooltip 
                  overlayInnerStyle={{width: '400px'}}
                  placement="right"
                  // visible={true}
                  title={getFilterMessage(currentVisitTypes)}
                  >
                    <InfoCircleOutlined style={{marginLeft: 10, verticalAlign: 'middle'}}/>
                  </Tooltip>
                </div>
              </div>} 
              //  extra={
                
              // }
              key="1" 
              forceRender={true} >
                <Row className="chart-summary-container summary-container">
                   {whetherDisplay('SoA at a Glance') && <Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper ` }> 
                   { ( localStorage.getItem('ts_id') !== "") && ( <SoaAtGlance saveCostChart={saveCostChart} trialId={props.trial_uuid} scenarioId={localStorage.getItem('ts_id')} onSoALoadingChange={handleSoALoading} chartData={chartData}
                   whetherSOA={true} 
                   soaOncologyFlag={soaOncologyFlag}
                   currentVisitTypes={currentVisitTypes} soaGlanceData={SOAByAtGlanceChart}
                   />)}
                   </Col>}
                   {whetherDisplay('Activities by Modality')&& <Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper` }>
                    <div className="chart-header">
                      <div className="title" >
                      Activities by modality
                      </div>
                    </div>
                    { modalityOptions && ( <ActivitiesByModality visits={props.newSoa?.soaVisits} modalityChartData={modalityChartData}  activityChart={handleActivityLoading} />)}
                  </Col>}
                  
                  {!soaOncologyFlag && whetherDisplay('Activity Utilization in Historical Trials')&& <Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper ` }> 
                    <div className="chart-header">
                      <div className="title">
                      Activity Utilization in Historical Trials
                      </div>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container" style={{padding: '5px 18px' }}> 
                      <Table
                        columns={activity_utilization_columns}
                        dataSource={ activityUtilization} 
                        pagination={{
                          position: ["bottomRight"],
                          showTotal: (total, range) => `${range[0]}-${range[1]} of ${ activityUtilization.length} items`,
                          defaultPageSize: 5, 
                        }}  
                      />
                    </div> 
                  </Col>}
                  {whetherDisplay('Count of SoA Activities by Activity Category')&& <Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper   cost-chart-wrapper` }> 
                    <div className="chart-header cost-header-wrapper">
                      <div className="title">
                        Count of Soa activities by activity category
                      </div>
                      <div className="legend">
                        <span>
                          <span className="circle" style={{backgroundColor: '#F27A26'}}></span>
                          Soa
                        </span>
                        <span>
                          <span className="circle" style={{backgroundColor: '#FBD0B3'}}></span>
                          Historical median
                        </span>
                      </div>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container">
                      <ReactECharts  option={countSOAbyCategoryOption} style={{  height: '400px'}} ></ReactECharts> 
                    </div>   
                  </Col>}
                  {whetherDisplay('Cost per Patient by Activity Category')&& <Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper ` }> 
                    <div className="chart-header">
                      <div className="title">
                        Cost per patient by activity category
                      </div>
                      <div className="legend">
                        <span>
                          <span className="circle" style={{backgroundColor: '#F27A26'}}></span>
                          Soa
                        </span>
                        <span>
                          <span className="circle" style={{backgroundColor: '#FBD0B3'}}></span>
                          Historical median
                        </span>
                      </div>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container">
                      <ReactECharts option={costPatientByCategoryOption} style={{ height: '400px'}}></ReactECharts> 
                    </div>  
                  </Col>}
                  {whetherDisplay('Top Activities by Cost')&& <Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper ` }> 
                    <div className="chart-header">
                      <div className="title">
                      Top activities by cost
                      {soaOncologyFlag &&
                      <Tooltip 
                        overlayInnerStyle={{width: '400px'}}
                        placement="right"
                        title={topActivitiesmessage}
                      >
                        <InfoCircleOutlined style={{marginLeft: 10, verticalAlign: 'middle', marginTop: -3}}/>
                      </Tooltip>
                      } 
                      </div>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container" style={{padding: '5px 18px' }}> 
                      <Table
                        columns={columnsTopActivity}
                        dataSource={topActivitiesbyCost} 
                        pagination={{
                          position: ["bottomRight"],
                          showTotal: (total, range) => `${range[0]}-${range[1]} of ${topActivitiesbyCost.length} items`,
                          defaultPageSize: 5, 
                        }}  
                      />
                    </div> 
                  </Col>}
                    {whetherDisplay('Patient burden by Dimension')&& <Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper ` }> 
                    <div className="chart-header">
                      <div className="title">
                      Patient burden by dimension
                      </div>
                      <Radio.Group
                        value={pbSelectedTab}
                        onChange={(e) => handleTabChange(e.target.value, 'pb')}
                        className="per-visit-tab"
                      >
                        <Radio.Button  value="pb_totalTrial">Total Trial</Radio.Button>
                        <Radio.Button  value="pb_perVisit">Per Visit</Radio.Button>
                      </Radio.Group>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container" style={{padding: '5px 18px' }}> 
                      <Table
                        columns={columns}
                        dataSource={dimensionBurden} 
                        pagination={{
                          position: ["bottomRight"],
                          showTotal: (total, range) => `${range[0]}-${range[1]} of ${dimensionBurden.length} items`,
                          defaultPageSize: 5, 
                        }}  
                      />
                    </div>  
                  </Col>}
                  {!soaOncologyFlag && whetherDisplay('Patient Burden by Visit')&&<Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper ` }> 
                    <div className="chart-header">
                      <div className="title">
                      Patient burden by visit
                      </div>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container">
                      <ReactECharts style={{height: '400px'}} option={visitChartOption}></ReactECharts> 
                    </div>  
                   </Col>}
                  {whetherDisplay('Patient Burden by Activity Category') &&<Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper ` }> 
                    <div className="chart-header">
                      <div className="title">
                        Patient burden by activity category
                      </div>
                      <div className="legend">
                        <span>
                          <span className="circle" style={{backgroundColor: '#F27A26'}}></span>
                          Soa
                        </span>
                        <span>
                          <span className="circle" style={{backgroundColor: '#FBD0B3'}}></span>
                          Historical median
                        </span>
                      </div>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container" style={{position: 'relative', left:'0px', top: '0px'}}>
                      <ReactECharts 
                      style={{height: '400px'}}
                      option={PBbyActivityCategoryOption}></ReactECharts> 
                    </div>  
                   </Col>}

                  {whetherDisplay('DCT Impact on Patient Burden')&& <Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper dct-impact-on-patient-burden` }> 
                    <div className="chart-header">
                      <div className="title">
                        DCT impact on patient burden
                      </div>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container">
                      <div className="left-part">
                        <div className="title-text-plain" style={{fontSize: 14, fontWeight: 600, paddingLeft: 10 }}>DCT impact on patient burden</div>
                        <div className="item-wrapper item-wrapper-top">
                          <div className="number">
                            {Math.round(DCTonPB.pb?.total_dct_pb)??'0'}
                          </div>
                          <div className="text">
                            Total patient burden
                            <br/>
                            with DCT
                          </div>
                        </div>
                        <div className="item-wrapper item-wrapper-bottom">
                          <div className="number">
                            {Math.round(DCTonPB.pb?.total_pb)??'0'}
                          </div>
                          <div className="text">
                            Total patient burden
                            <br/>
                            without DCT
                          </div>
                        </div>
                      </div>
                      <div className="middle"> </div>
                      <div className="right-part">
                        <div className="title" style={{fontWeight: 600}}>
                          Patient burden modification by dimension
                        </div>
                        <div className="chart-content">
                        {
                        DCTonPBInsightsData&&DCTonPBInsightsData.length > 0 && DCTonPBInsightsData.reduce((accumulator, currentValue) => {
                          return accumulator + currentValue.dct_patient_burden;
                        }, 0) > 0 ? 
                            <ReactECharts option={DCTonPBOption}></ReactECharts> : (
                            <div className="blank">
                              Based on your current activity and modality selections, none of the patient burden dimensions have a modification in patient burden due to the application of DCT capabilities. Try adding DCT capabilities to further reduce your patient burden.
                            </div>
                          )
                        } 
                        </div>
                      </div>
                    </div> 
                  </Col>}
                  {!soaOncologyFlag && whetherDisplay('Cost per Patient by Visit')&& <Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper ` }> 
                    <div className="chart-header">
                      <div className="title">
                      Cost per patient by visit
                      </div>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container">
                      <ReactECharts style={{height: '400px'}} option={costVisitChartOption}></ReactECharts> 
                    </div>  
                  </Col>}
                
                  {!soaOncologyFlag && whetherDisplay('Count of SoA Activities by Visit')&&<Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper ` }> 
                    <div className="chart-header">
                      <div className="title">
                      Count of Soa activities by visit
                      </div>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container" style={{paddingLeft: '8px'}}>
                      <ReactECharts style={{height: '400px'}} option={soaActivitiesChartOption}></ReactECharts> 
                    </div>  
                  </Col>}

                  {whetherDisplay('OH Site burden by dimension')&& <Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper ` }> 
                    <div className="chart-header">
                      <div className="title">
                      Site burden by dimension
                      </div>
                      <Radio.Group
                        value={sbSelectedTab}
                        onChange={(e) => handleTabChange(e.target.value, 'sb')}
                        className="per-visit-tab"
                      ><Radio.Button  value="sb_totalTrial">Total Trial</Radio.Button>
                          <Radio.Button  value="sb_perVisit">Per Visit</Radio.Button>
                      </Radio.Group>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container" style={{padding: '5px 18px' }}> 
                      <Table
                        columns={sDDimensionColumns}
                        dataSource={sDDimensionBurden} 
                        pagination={{
                          position: ["bottomRight"],
                          showTotal: (total, range) => `${range[0]}-${range[1]} of ${sDDimensionBurden.length} items`,
                          defaultPageSize: 5, 
                        }}  
                      />
                    </div>  
                  </Col>}

                  {whetherDisplay('DCT Impact on OH Site Burden')&& <Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper dct-impact-on-patient-burden` }> 
                    <div className="chart-header">
                      <div className="title">
                        DCT impact on site burden
                      </div>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container">
                      <div className="left-part">
                        <div className="title-text-plain" style={{fontSize: 14, fontWeight: 600, paddingLeft: 10 }}>DCT impact on site burden</div>
                        <div className="item-wrapper item-wrapper-top">
                          <div className="number">
                            {Math.round(DCTonSB.sb?.total_dct_sb)??'0'}
                          </div>
                          <div className="text">
                            Total site burden
                            <br/>
                            with DCT
                          </div>
                        </div>
                        <div className="item-wrapper item-wrapper-bottom">
                          <div className="number">
                            {Math.round(DCTonSB.sb?.total_sb)??'0'}
                          </div>
                          <div className="text">
                            Total site burden
                            <br/>
                            without DCT
                          </div>
                        </div>
                      </div>
                      <div className="middle"> </div>
                      <div className="right-part">
                        <div className="title" style={{fontWeight: 600}}>
                          Site burden modification by dimension
                        </div>
                        <div className="chart-content">
                        {
                        DCTonSBInsightsData&&DCTonSBInsightsData.length > 0 && DCTonSBInsightsData.reduce((accumulator, currentValue) => {
                          return accumulator + currentValue.oh_dct_site_burden;
                        }, 0) > 0 ? 
                            <ReactECharts option={DCTonSBOption}></ReactECharts> : (
                            <div className="blank">
                              Based on your current activity and modality selections, none of the site burden dimensions have a modification in site burden due to the application of DCT capabilities. Try adding DCT capabilities to further reduce your site burden.
                            </div>
                          )
                        } 
                        </div>
                      </div>
                    </div>
                  </Col>}

                  {whetherDisplay('Time Spent in Trial')&&<Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper ` }>
                    <div className="chart-header" style={{flexDirection: 'column'}}>
                      <div className="title">
                        Time spent in trial
                      </div>
                      <Radio.Group value={siteTimeTab} onChange={onSiteTimeTabChange} className="site-time-tab" style={{display: 'none'}}>
                        <Radio.Button value="total_trial">Total Trial</Radio.Button>
                        <Radio.Button value="per_visit">Per Visit</Radio.Button>
                      </Radio.Group>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                      <div className="role-content">
                        <div className="left">
                          <div className="time">
                          {displayTimeInHoursOrMins(timeSpentInTrial?.scenario_time)}
                          </div>
                          <div className="role">
                            Patient
                          </div>
                        </div>
                        <div className="right">
                          Median from similar historical trials- <b>{displayTimeInHoursOrMins(timeSpentInTrial?.historic_time)}</b>
                        </div>
                      </div>
                    </div>
                    <div className="chart-container" style={{padding: '5px 18px' }}>
                    {
                      siteTimeTab === 'total_trial'? (
                      <Table
                        columns={time_spent_columns}
                        dataSource={timeSpentByRole}
                        components={{
                          header: {
                            wrapper: CustomHeaderWrapper,
                          },
                        }}
                        pagination={{
                          position: ["bottomRight"],
                          showTotal: (total, range) => `${range[0]}-${range[1]} of ${timeSpentByRole.length} items`,
                          defaultPageSize: 5,
                        }}
                      />
                      ):(
                        <div></div>
                      )
                    }
                    </div>
                  </Col>}

                  {whetherDisplay('Time spent by activity category') &&<Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper ` }> 
                    <div className="chart-header">
                      <div className="title">
                        Time spent by activity category
                      </div>
                      <div className="legend">
                        <span>
                          <span className="circle" style={{backgroundColor: '#F27A26'}}></span>
                          Soa
                        </span>
                        <span>
                          <span className="circle" style={{backgroundColor: '#FBD0B3'}}></span>
                          Historical median
                        </span>
                      </div>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container" style={{position: 'relative', left:'0px', top: '0px'}}>
                      <ReactECharts 
                      style={{height: '400px'}}
                      option={TimeByCategoryOption}></ReactECharts> 
                    </div>
                    </Col>}
                  {!soaOncologyFlag && whetherDisplay('Site Burden by Visit')&&<Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper ` }> 
                    <div className="chart-header">
                      <div className="title">
                      Site burden by visit
                      </div>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container">
                      <ReactECharts style={{height: '400px'}} option={sitevisitChartOption}></ReactECharts> 
                    </div>  
                   </Col>}

                   {!soaOncologyFlag && whetherDisplay('Time spent by visit')&&<Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper ` }> 
                    <div className="chart-header">
                      <div className="title">
                      Time spent by visit
                      </div>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container">
                      <ReactECharts 
                          style={{height: '400px'}} 
                          option={TimeSpentByVisitOption}
                          onChartReady={onChartReady}
                        >
                      </ReactECharts> 
                       {tooltipVisible && (
                              <div  ref={tooltipRef}>
                                <Tooltip
                                  title={tooltipContent}
                                  visible={tooltipVisible}
                                  onVisibleChange={(visible) => setTooltipVisible(visible)}
                                  overlayClassName="tooltip-overlay"
                                  overlayInnerStyle={{
                                    maxHeight: '180px',  
                                    overflowY: 'auto',
                                    backgroundColor: '#ffffff',
                                    color: '#000000',
                                    borderRadius: '5px',
                                    width:'420px'
                                  }}
                                >
                                  <div 
                                  className='tooltip-target'
                                  style={{  left: tooltipPosition.x, top: tooltipPosition.y}} />
                                </Tooltip>
                              </div>
                        )}
                    </div>  
                   </Col>}
                   
                   {whetherDisplay('Site Burden by Activity Category') &&<Col span={11} className={`${hiddeTags ? 'hidde' : ''} chart-wrapper ` }> 
                    <div className="chart-header">
                      <div className="title">
                        Site burden by activity category
                      </div>
                      <div className="legend">
                        <span>
                          <span className="circle" style={{backgroundColor: '#F27A26'}}></span>
                          Soa
                        </span>
                        <span>
                          <span className="circle" style={{backgroundColor: '#FBD0B3'}}></span>
                          Historical median
                        </span>
                      </div>
                      <CheckCircleFilled style={{color: '#97E095', display: "none"}}/>
                    </div>
                    <div className="chart-container" style={{position: 'relative', left:'0px', top: '0px'}}>
                      <ReactECharts 
                      style={{height: '400px'}}
                      option={SBbyActivityCategoryOption}></ReactECharts> 
                    </div>  
                   </Col>}
                </Row>
                <br></br>
                <Row className={`tab-container ${tabs.includes('Custom') ? 'custom-present' : ''}`}>
                {tabs.map((tab,index) => (
                  <Col span={tabs.includes('Custom') ? 3 : 4}
                  key={index}
                  className={`tab ${tabs.includes('Custom') ? 'custom-tab' : ''}`}
                  onClick={() =>handleTabClick(tab)}
                >
                    <div className={`tab-indicator ${tab === activeTab ? 'active' : 'inactive'}`}/>
                          {tab}
                  </Col>

                ))}
                <Col className="view-all-col">
                  <div
                    className="view-all-button"
                    style={!tabs.includes('Custom')? {marginLeft: '50px'}: {}}
                    onClick={onViewImpactSummaryClick}>View all</div>
                </Col>
                </Row>
              </Panel>
            </Collapse>
         
            {props.newSoa && (<NewEventList 
              endpoints={endpoints}
              saveEvents={saveEvents}
              handleEventChange={handleEventChange}
              numbers={editNumbers}
              periodData={periodDataDetails}
              soaOncologyFlag={soaOncologyFlag}
              currentVisitTypes={currentVisitTypes}
              visitTypeLib={visitTypeLib}
              labs={addedLabs}
              examination={addedExamination}
              procedures={addedProcedures}
              questionnaire={addedQuestionnaires}
              studyProcedures={addedStudyProcedures}
              weeks={weeks}
              visits={visits}
              submitType={submitType}
              showConfigureModal={showConfigureModal}
              modalityOptions={modalityOptions}
              handleEvent={handleEvent}
              readOnlyUser={trialUserRole}
              windowResize={windowResize}
              visitNoteListHandler={handleVisitNoteList}
              visitsList={visitNoteList}
              // resetNotes={handleResetNotes}
              soeReadOnly={props.readOnly}
              soeLibrarayPanelStatus={soeLibrarayPanelStatus}
              orgLabs={orgLabs}
              orgExamination={orgExamination}
              orgProcedures={orgProcedures}
              orgQuestionnaires={orgQuestionnaires}
              orgStudyProcedures={orgStudyProcedures}
              filteredLabs={props?.newSoa?.soaFilteredLabs}
              filteredExamination={props?.newSoa?.soaFilteredExamination}
              filteredQuestionnaires={props?.newSoa?.soaFilteredQuestionnaires}
              filteredProcedures={props?.newSoa?.soaFilteredProcedures}
              filteredStudyProcedures={props?.newSoa?.soaFilteredStudyProcedures}
              similarHistoricalTrials= {props.nctList}
              trial_id={props.trial_uuid}
              scenarioId={localStorage.getItem('ts_id')} 
              scenarioType={props.scenarioType}
              loadingSoaAtGlance={loadingSoaAtGlance}
              chartLoading={isChartLoading}
              saveButton={disableSave}
              openSoaDetailsModal={openSoaDetailsModal}
              selection={soaModalDetails}
              resetAddInsights={resetAddInsights}
              updateAddedCategory={updateAddedCategory} 
              periodDataUpdate={periodDataUpdateHandler}
            />)}
            
           
            </Col>
              
            <Col span={soeLibrarayPanelStatus ? 6: 1} 
            className="right-insight-container">
              <Row>
              {eventPanel=="2"&&(
            <Col span={21} className="left-insight" 
            style={{
              backgroundColor: '#F8F8F8'
            }}>
              <Row style={{backgroundColor: '#F8F8F8'}}>
                <Col span={24}>
                  <div className="item-header">
                    <span> Insights </span>
                    {/* <span> Insights ({insightEvent? filterAddedInsights(insightEvent).filter(o => o.action === "ADD").slice(0, 3).length+ filterAddedInsights(insightEvent).filter(i => i.action === "REMOVE").slice(0,3).length : 0})
                  </span> */}
                   
                  </div>
                </Col>
                <Col span={24} className="content-outer insight-box-wrapper">
                  {insightEvent && filterAddedInsights(insightEvent).filter(o => o.action === "ADD").slice(0, 3).map((item) => {
                    return (
                    // return o.action === "ADD" ? (
                      <div className="insight-box">
                        <div className="head">Suggested to add</div>
                        <div className="content"><b>{item.activity}</b> occurs {getPeriodTypeText()} in <b>{Math.round(item.frequency * 10000) / 100 + "%"}</b> of similar trials. Consider adding it to {getPeriodTypeSecondText()}your scenario.</div>
                        <div className="button-area">
                          <span className="button-left" onClick={e=>onInsightClick(item, 'add')}>
                            <PlusOutlined style={{margin:"0 3px 0 0"}}/> Add activity
                          </span>
                          <span className="button-right" onClick={e=>onDismiss(item)}>
                            <DeleteOutlined style={{margin:"0 3px 0 0"}} /> Dismiss
                          </span>
                        </div>
                      </div>
                    )
                  })}
                    {insightEvent && filterAddedInsights(insightEvent).filter(i => i.action === "REMOVE").slice(0,3).map((o) => {
                      return (
                      <div className="insight-box">
                        <div className="head">Suggested to remove</div>
                        <div className="content"> <b>{o.activity}</b> occurs {getPeriodTypeText()} in <b>{Math.round(o.frequency * 10000) / 100 + "%"}</b> of similar trials. Consider removing it from {getPeriodTypeSecondText()}your scenario.</div>
                        <div className="button-area">
                          <span className="button-left" onClick={e=>onInsightClick(o, 'remove')}>
                            <MinusOutlined style={{margin:"0 3px 0 0"}}/> Remove activity
                          </span>
                          <span className="button-right" onClick={e=>onDismiss(o)}>
                            <DeleteOutlined style={{margin:"0 3px 0 0"}} /> Dismiss
                          </span>
                        </div>
                      </div>
                    )
                  })}
                </Col>
              </Row>
            </Col>
            )}

            <Col span={1} className="right-icon" style={{maxWidth: '50px', minWidth: '50px', background: '#FFFFFF'}}>
                <div className={`side-toolbar ${eventLib > 0 ? '' : ''}`}> 
                <Badge style={{marginTop: '20px'}} count={insightEvent?filterAddedInsights(insightEvent).length:0} showZero={insightEvent && filterAddedInsights(insightEvent).length == 0 ? true : false }>
                <Tooltip placement="right" title={'Insights'}>
                  {eventPanel==="2"&&(
                    <CarryOutFilled style={{color:"#404042", fontSize: "18px", marginLeft: "15px", marginTop: "20px", paddingTop: "12px", cursor: "pointer"}} onClick={()=> {
                      setEventPanel("1")
                      soeInsightsToggleHandler(false)
                        }}/>
                  )}
                  {eventPanel==="1"&&(
                     <CarryOutFilled style={{color:"#999999", fontSize: "18px", marginLeft: "15px", marginTop: "20px", paddingTop: "12px", cursor: "pointer"}} onClick={()=> {
                      setEventPanel("2")
                      soeInsightsToggleHandler(true)
                        }}/>
                  )}
                </Tooltip>
                </Badge>
                {!soeLibrarayPanelStatus &&  <div className="action-wrapper"></div>} 
              </div>
            </Col>
              </Row> 
           </Col>
        {/* </Row>  */}
      </div>
    </div>

   <SOAConfigure 
      key={showConfigure} 
      visible={showConfigure}
      editNumbers={editNumbers}
      cancelHandler={handleCancel}
      submitHandler={handleCloseConfigure}
      soaOncologyFlag={soaOncologyFlag}
      periodDataDetails={periodDataDetails}
      visitTypeLib={visitTypeLib}
    />
    </>)
}

const mapDispatchToProps = (dispatch) => ({
    createTrial: (val) => dispatch(createActions.createTrial(val)),
    createSoa: (val) => dispatch(createActions.createSoa(val)),
    updateSoaActivities: (val) => dispatch(createActions.updateSoaActivities(val)),
    updateEndpoints: (val) => dispatch(createActions.updateEndpoints(val))
  });
  
  const mapStateToProps = (state) => ({
    newTrial: state.trialReducer,
    newSoa: state.soaReducer,
  });
  export default connect(mapStateToProps, mapDispatchToProps)(ScheduleActivities);


